/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-interface, @typescript-eslint/naming-convention */
/**
 * ИС "Продовольствие"
 * Целями создания ИС «Учет идентификационных карт» являются упрощение и ускорение выдачи идентификационных карт
      и продовольствия по ним гражданам Ростовской области в период введения особого положения в регионе, а также учет
      выданных карт и продовольствия по ним для оперативного формирования плана обеспечения региона.
 *
 * OpenAPI spec version: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import { BASE_PATH, HttpClient, HttpRequest, HttpRequestHeaders, HttpRequestOptions, HttpRequestOptionsInit, BaseAPI, RequiredError } from "./runtime";
import { Api } from "./models";
import { Context, HttpHeader } from '../../common'

export type FactoryFunction<T> = (client: HttpClient, configuration?: Configuration, basePath?: string) => T;

export namespace ActualIssueProductsApi {
	export type ActualIssueProductsAddResponse =
		| ActualIssueProductsAdd200Response
	
	export interface ActualIssueProductsAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ActualIssueProductsAdd200Response
		headers?: undefined
	}
	
	export interface ActualIssueProductsFormReportParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Фильтр по ID муниципального образования</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Фильтр по дате создания записи (от)</p>
		 * @type {string}
		 */
		dateFrom?: string
		/**
		 * @description <p>Фильтр по дате создания записи (до)</p>
		 * @type {string}
		 */
		dateTo?: string
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type ActualIssueProductsFormReportResponse =
		| ActualIssueProductsFormReport200Response
	
	export interface ActualIssueProductsFormReport200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ActualIssueProductsFormReport200Response
		headers?: undefined
	}
	
}

/**
 * ActualIssueProductsApi - request creator
 * @export
 */
export const ActualIssueProductsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление новой записи о выданном продовольствии
		 * @param {Api.AddActualIssueProduct} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		actualIssueProductsAdd(ctx: Context, request: Api.AddActualIssueProduct, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling actualIssueProductsAdd.');
			}

			let localVarPath = `/api/v1/actual-issue-products/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получить список записей учёта о выданном продовольствии
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
		 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		actualIssueProductsFormReport(ctx: Context, params: ActualIssueProductsApi.ActualIssueProductsFormReportParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/actual-issue-products/form-report`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.dateFrom !== undefined) {
				localVarQueryParameter.append('dateFrom', String(params.dateFrom));
			}

			if (params.dateTo !== undefined) {
				localVarQueryParameter.append('dateTo', String(params.dateTo));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * ActualIssueProductsApi - functional programming interface
 * @export
 */
export const ActualIssueProductsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление новой записи о выданном продовольствии
		 * @param {Api.AddActualIssueProduct} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		actualIssueProductsAdd(ctx: Context, request: Api.AddActualIssueProduct, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ActualIssueProductsApi.ActualIssueProductsAddResponse> {
			const localVarHttpRequest = ActualIssueProductsApiHttpRequestCreator(configuration).actualIssueProductsAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ActualIssueProductsAdd200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получить список записей учёта о выданном продовольствии
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
		 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		actualIssueProductsFormReport(ctx: Context, params: ActualIssueProductsApi.ActualIssueProductsFormReportParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ActualIssueProductsApi.ActualIssueProductsFormReportResponse> {
			const localVarHttpRequest = ActualIssueProductsApiHttpRequestCreator(configuration).actualIssueProductsFormReport(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ActualIssueProductsFormReport200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * ActualIssueProductsApi - factory interface
 * @export
 */
export const ActualIssueProductsApiFactory: FactoryFunction<ActualIssueProductsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new ActualIssueProductsApi(client, configuration, basePath);
};

/**
 * ActualIssueProductsApi - interface
 * @export
 * @interface ActualIssueProductsApi
 */
export interface ActualIssueProductsApiInterface {
	/**
	 * @summary Добавление новой записи о выданном продовольствии
	 * @param {Api.AddActualIssueProduct} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	actualIssueProductsAdd(ctx: Context, request: Api.AddActualIssueProduct, options?: HttpRequestOptionsInit): Promise<ActualIssueProductsApi.ActualIssueProductsAddResponse>

	/**
	 * @summary Получить список записей учёта о выданном продовольствии
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
	 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	actualIssueProductsFormReport(ctx: Context, params: ActualIssueProductsApi.ActualIssueProductsFormReportParameters, options?: HttpRequestOptionsInit): Promise<ActualIssueProductsApi.ActualIssueProductsFormReportResponse>

}

/**
 * ActualIssueProductsApi - object-oriented interface
 * @export
 * @class ActualIssueProductsApi
 * @extends {BaseAPI}
 */
export class ActualIssueProductsApi extends BaseAPI implements ActualIssueProductsApiInterface {
	/**
	 * @summary Добавление новой записи о выданном продовольствии
	 * @param {Api.AddActualIssueProduct} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public actualIssueProductsAdd(ctx: Context, request: Api.AddActualIssueProduct, options?: HttpRequestOptionsInit) {
		return ActualIssueProductsApiFp(this.configuration).actualIssueProductsAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получить список записей учёта о выданном продовольствии
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
	 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public actualIssueProductsFormReport(ctx: Context, params: ActualIssueProductsApi.ActualIssueProductsFormReportParameters, options?: HttpRequestOptionsInit) {
		return ActualIssueProductsApiFp(this.configuration).actualIssueProductsFormReport(ctx, params, options)(this.client, this.basePath);
	}

}
export namespace AddressesApi {
	export interface AddressesSuggestParameters {
		/**
		 * @description <p>Уровень дополняемого адреса (город, улица, дом)</p>
		 * @type {Api.AddressesSuggestLevel}
		 */
		level: Api.AddressesSuggestLevel
		/**
		 * @description <p>Строка поиска</p>
		 * @type {string}
		 */
		search: string
		/**
		 * @description <p>ID муниципального образования</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Значение поля &quot;Населенный пункт&quot; если оно уже выбрано</p>
		 * @type {string}
		 */
		locality?: string
		/**
		 * @description <p>Значение поля &quot;Улица&quot; если оно уже выбрано</p>
		 * @type {string}
		 */
		street?: string
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type AddressesSuggestResponse =
		| AddressesSuggest200Response
	
	export interface AddressesSuggest200Response {
		status: 200
		contentType: 'application/json'
		body: Api.AddressesSuggest200Response
		headers?: undefined
	}
	
	export type KladrImportResponse =
		| KladrImport200Response
	
	export interface KladrImport200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * AddressesApi - request creator
 * @export
 */
export const AddressesApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Дополнение вводимого адреса
		 * @param {Api.AddressesSuggestLevel} level <p>Уровень дополняемого адреса (город, улица, дом)</p>
		 * @param {string} search <p>Строка поиска</p>
		 * @param {string} [municipalEntityId] <p>ID муниципального образования</p>
		 * @param {string} [locality] <p>Значение поля &quot;Населенный пункт&quot; если оно уже выбрано</p>
		 * @param {string} [street] <p>Значение поля &quot;Улица&quot; если оно уже выбрано</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		addressesSuggest(ctx: Context, params: AddressesApi.AddressesSuggestParameters, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'level' is not null or undefined
			if (params.level === null || params.level === undefined) {
				throw new RequiredError('level', 'Required parameter level was null or undefined when calling addressesSuggest.');
			}
			// verify required parameter 'search' is not null or undefined
			if (params.search === null || params.search === undefined) {
				throw new RequiredError('search', 'Required parameter search was null or undefined when calling addressesSuggest.');
			}

			let localVarPath = `/api/v1/addresses/suggest`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.level !== undefined) {
				localVarQueryParameter.append('level', String(params.level));
			}

			if (params.search !== undefined) {
				localVarQueryParameter.append('search', String(params.search));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.locality !== undefined) {
				localVarQueryParameter.append('locality', String(params.locality));
			}

			if (params.street !== undefined) {
				localVarQueryParameter.append('street', String(params.street));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Вгрузка справочника КЛАДР
		 * @param {string | Blob} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		kladrImport(ctx: Context, request: string | Blob | undefined, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/addresses/kladr-import`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/x-7z-compressed';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = request;
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Дополнение вводимого адреса
		 * @param {Api.AddressesSuggestLevel} level <p>Уровень дополняемого адреса (город, улица, дом)</p>
		 * @param {string} search <p>Строка поиска</p>
		 * @param {string} [municipalEntityId] <p>ID муниципального образования</p>
		 * @param {string} [locality] <p>Значение поля &quot;Населенный пункт&quot; если оно уже выбрано</p>
		 * @param {string} [street] <p>Значение поля &quot;Улица&quot; если оно уже выбрано</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		addressesSuggest(ctx: Context, params: AddressesApi.AddressesSuggestParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<AddressesApi.AddressesSuggestResponse> {
			const localVarHttpRequest = AddressesApiHttpRequestCreator(configuration).addressesSuggest(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.AddressesSuggest200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Вгрузка справочника КЛАДР
		 * @param {string | Blob} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		kladrImport(ctx: Context, request: string | Blob | undefined, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<AddressesApi.KladrImportResponse> {
			const localVarHttpRequest = AddressesApiHttpRequestCreator(configuration).kladrImport(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory: FactoryFunction<AddressesApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new AddressesApi(client, configuration, basePath);
};

/**
 * AddressesApi - interface
 * @export
 * @interface AddressesApi
 */
export interface AddressesApiInterface {
	/**
	 * @summary Дополнение вводимого адреса
	 * @param {Api.AddressesSuggestLevel} level <p>Уровень дополняемого адреса (город, улица, дом)</p>
	 * @param {string} search <p>Строка поиска</p>
	 * @param {string} [municipalEntityId] <p>ID муниципального образования</p>
	 * @param {string} [locality] <p>Значение поля &quot;Населенный пункт&quot; если оно уже выбрано</p>
	 * @param {string} [street] <p>Значение поля &quot;Улица&quot; если оно уже выбрано</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	addressesSuggest(ctx: Context, params: AddressesApi.AddressesSuggestParameters, options?: HttpRequestOptionsInit): Promise<AddressesApi.AddressesSuggestResponse>

	/**
	 * @summary Вгрузка справочника КЛАДР
	 * @param {string | Blob} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	kladrImport(ctx: Context, request: string | Blob | undefined, options?: HttpRequestOptionsInit): Promise<AddressesApi.KladrImportResponse>

}

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI implements AddressesApiInterface {
	/**
	 * @summary Дополнение вводимого адреса
	 * @param {Api.AddressesSuggestLevel} level <p>Уровень дополняемого адреса (город, улица, дом)</p>
	 * @param {string} search <p>Строка поиска</p>
	 * @param {string} [municipalEntityId] <p>ID муниципального образования</p>
	 * @param {string} [locality] <p>Значение поля &quot;Населенный пункт&quot; если оно уже выбрано</p>
	 * @param {string} [street] <p>Значение поля &quot;Улица&quot; если оно уже выбрано</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public addressesSuggest(ctx: Context, params: AddressesApi.AddressesSuggestParameters, options?: HttpRequestOptionsInit) {
		return AddressesApiFp(this.configuration).addressesSuggest(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Вгрузка справочника КЛАДР
	 * @param {string | Blob} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public kladrImport(ctx: Context, request: string | Blob | undefined, options?: HttpRequestOptionsInit) {
		return AddressesApiFp(this.configuration).kladrImport(ctx, request, options)(this.client, this.basePath);
	}

}
export namespace AuthApi {
	export type AuthGetControlQuestionResponse =
		| AuthGetControlQuestion200Response
	
	export interface AuthGetControlQuestion200Response {
		status: 200
		contentType: 'application/json'
		body: Api.AuthGetControlQuestion200Response
		headers?: undefined
	}
	
	export type AuthLoginResponse =
		| AuthLogin200Response
	
	export interface AuthLogin200Response {
		status: 200
		contentType: 'application/json'
		body: Api.AuthSuccessResponse
		headers?: undefined
	}
	
	export type AuthLoginByResponse =
		| AuthLoginBy200Response
	
	export interface AuthLoginBy200Response {
		status: 200
		contentType: 'application/json'
		body: Api.AuthSuccessResponse
		headers?: undefined
	}
	
	export type AuthLogoutResponse =
		| AuthLogout200Response
	
	export interface AuthLogout200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * AuthApi - request creator
 * @export
 */
export const AuthApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Запрос контрольного вопроса
		 * @param {string} email <p>email пользователя для получения его вопроса</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authGetControlQuestion(ctx: Context, email: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'email' is not null or undefined
			if (email === null || email === undefined) {
				throw new RequiredError('email', 'Required parameter email was null or undefined when calling authGetControlQuestion.');
			}

			let localVarPath = `/api/v1/auth/control-question`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (email !== undefined) {
				localVarQueryParameter.append('email', String(email));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Вход по email и паролю
		 * @param {Api.AuthLoginRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authLogin(ctx: Context, request: Api.AuthLoginRequest, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling authLogin.');
			}

			let localVarPath = `/api/v1/auth/login`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Вход по контрольному вопросу или коду
		 * @param {Api.AuthLoginByRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authLoginBy(ctx: Context, request: Api.AuthLoginByRequest, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling authLoginBy.');
			}

			let localVarPath = `/api/v1/auth/login-by`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Выход
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authLogout(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/auth/logout`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Запрос контрольного вопроса
		 * @param {string} email <p>email пользователя для получения его вопроса</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authGetControlQuestion(ctx: Context, email: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<AuthApi.AuthGetControlQuestionResponse> {
			const localVarHttpRequest = AuthApiHttpRequestCreator(configuration).authGetControlQuestion(ctx, email, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.AuthGetControlQuestion200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Вход по email и паролю
		 * @param {Api.AuthLoginRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authLogin(ctx: Context, request: Api.AuthLoginRequest, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<AuthApi.AuthLoginResponse> {
			const localVarHttpRequest = AuthApiHttpRequestCreator(configuration).authLogin(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.AuthSuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Вход по контрольному вопросу или коду
		 * @param {Api.AuthLoginByRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authLoginBy(ctx: Context, request: Api.AuthLoginByRequest, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<AuthApi.AuthLoginByResponse> {
			const localVarHttpRequest = AuthApiHttpRequestCreator(configuration).authLoginBy(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.AuthSuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Выход
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		authLogout(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<AuthApi.AuthLogoutResponse> {
			const localVarHttpRequest = AuthApiHttpRequestCreator(configuration).authLogout(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory: FactoryFunction<AuthApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new AuthApi(client, configuration, basePath);
};

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
	/**
	 * @summary Запрос контрольного вопроса
	 * @param {string} email <p>email пользователя для получения его вопроса</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	authGetControlQuestion(ctx: Context, email: string, options?: HttpRequestOptionsInit): Promise<AuthApi.AuthGetControlQuestionResponse>

	/**
	 * @summary Вход по email и паролю
	 * @param {Api.AuthLoginRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	authLogin(ctx: Context, request: Api.AuthLoginRequest, options?: HttpRequestOptionsInit): Promise<AuthApi.AuthLoginResponse>

	/**
	 * @summary Вход по контрольному вопросу или коду
	 * @param {Api.AuthLoginByRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	authLoginBy(ctx: Context, request: Api.AuthLoginByRequest, options?: HttpRequestOptionsInit): Promise<AuthApi.AuthLoginByResponse>

	/**
	 * @summary Выход
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	authLogout(ctx: Context, options?: HttpRequestOptionsInit): Promise<AuthApi.AuthLogoutResponse>

}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
	/**
	 * @summary Запрос контрольного вопроса
	 * @param {string} email <p>email пользователя для получения его вопроса</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public authGetControlQuestion(ctx: Context, email: string, options?: HttpRequestOptionsInit) {
		return AuthApiFp(this.configuration).authGetControlQuestion(ctx, email, options)(this.client, this.basePath);
	}

	/**
	 * @summary Вход по email и паролю
	 * @param {Api.AuthLoginRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public authLogin(ctx: Context, request: Api.AuthLoginRequest, options?: HttpRequestOptionsInit) {
		return AuthApiFp(this.configuration).authLogin(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Вход по контрольному вопросу или коду
	 * @param {Api.AuthLoginByRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public authLoginBy(ctx: Context, request: Api.AuthLoginByRequest, options?: HttpRequestOptionsInit) {
		return AuthApiFp(this.configuration).authLoginBy(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Выход
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public authLogout(ctx: Context, options?: HttpRequestOptionsInit) {
		return AuthApiFp(this.configuration).authLogout(ctx, options)(this.client, this.basePath);
	}

}
export namespace CardIssuePointsApi {
	export type CardIssuePointsAddResponse =
		| CardIssuePointsAdd200Response
	
	export interface CardIssuePointsAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CardIssuePointsAdd200Response
		headers?: undefined
	}
	
	export type CardIssuePointsDeleteResponse =
		| CardIssuePointsDelete200Response
	
	export interface CardIssuePointsDelete200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
	export type CardIssuePointsGetByIdResponse =
		| CardIssuePointsGetById200Response
	
	export interface CardIssuePointsGetById200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CardIssuePointsGetById200Response
		headers?: undefined
	}
	
	export interface CardIssuePointsGetListParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Фильтр по ID муниципального образования</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Полнотекстовый фильтр по адресу</p>
		 * @type {string}
		 */
		search?: string
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.CardIssuePointsGetListOrderBy}
		 */
		orderBy?: Api.CardIssuePointsGetListOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.CardIssuePointsGetListDirection}
		 */
		direction?: Api.CardIssuePointsGetListDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type CardIssuePointsGetListResponse =
		| CardIssuePointsGetList200Response
	
	export interface CardIssuePointsGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CardIssuePointsGetList200Response
		headers?: undefined
	}
	
	export type CardIssuePointsUpdateResponse =
		| CardIssuePointsUpdate200Response
	
	export interface CardIssuePointsUpdate200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * CardIssuePointsApi - request creator
 * @export
 */
export const CardIssuePointsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление нового пункта выдачи карт
		 * @param {Api.AddCardIssuePoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsAdd(ctx: Context, request: Api.AddCardIssuePoint, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling cardIssuePointsAdd.');
			}

			let localVarPath = `/api/v1/card-issue-points/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Удаление пункта выдачи карт
		 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsDelete(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling cardIssuePointsDelete.');
			}

			let localVarPath = `/api/v1/card-issue-points/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'DELETE', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение пункта выдачи карт по ID
		 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsGetById(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling cardIssuePointsGetById.');
			}

			let localVarPath = `/api/v1/card-issue-points/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение списка пунктов выдачи карт
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по адресу</p>
		 * @param {Api.CardIssuePointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.CardIssuePointsGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsGetList(ctx: Context, params: CardIssuePointsApi.CardIssuePointsGetListParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/card-issue-points/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.search !== undefined) {
				localVarQueryParameter.append('search', String(params.search));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Обновление пункта выдачи карт
		 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
		 * @param {Api.UpdateCardIssuePoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsUpdate(ctx: Context, id: string, request: Api.UpdateCardIssuePoint, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling cardIssuePointsUpdate.');
			}
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling cardIssuePointsUpdate.');
			}

			let localVarPath = `/api/v1/card-issue-points/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'PATCH', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * CardIssuePointsApi - functional programming interface
 * @export
 */
export const CardIssuePointsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление нового пункта выдачи карт
		 * @param {Api.AddCardIssuePoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsAdd(ctx: Context, request: Api.AddCardIssuePoint, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CardIssuePointsApi.CardIssuePointsAddResponse> {
			const localVarHttpRequest = CardIssuePointsApiHttpRequestCreator(configuration).cardIssuePointsAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CardIssuePointsAdd200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Удаление пункта выдачи карт
		 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CardIssuePointsApi.CardIssuePointsDeleteResponse> {
			const localVarHttpRequest = CardIssuePointsApiHttpRequestCreator(configuration).cardIssuePointsDelete(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение пункта выдачи карт по ID
		 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CardIssuePointsApi.CardIssuePointsGetByIdResponse> {
			const localVarHttpRequest = CardIssuePointsApiHttpRequestCreator(configuration).cardIssuePointsGetById(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CardIssuePointsGetById200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение списка пунктов выдачи карт
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по адресу</p>
		 * @param {Api.CardIssuePointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.CardIssuePointsGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsGetList(ctx: Context, params: CardIssuePointsApi.CardIssuePointsGetListParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CardIssuePointsApi.CardIssuePointsGetListResponse> {
			const localVarHttpRequest = CardIssuePointsApiHttpRequestCreator(configuration).cardIssuePointsGetList(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CardIssuePointsGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Обновление пункта выдачи карт
		 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
		 * @param {Api.UpdateCardIssuePoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		cardIssuePointsUpdate(ctx: Context, id: string, request: Api.UpdateCardIssuePoint, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CardIssuePointsApi.CardIssuePointsUpdateResponse> {
			const localVarHttpRequest = CardIssuePointsApiHttpRequestCreator(configuration).cardIssuePointsUpdate(ctx, id, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * CardIssuePointsApi - factory interface
 * @export
 */
export const CardIssuePointsApiFactory: FactoryFunction<CardIssuePointsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new CardIssuePointsApi(client, configuration, basePath);
};

/**
 * CardIssuePointsApi - interface
 * @export
 * @interface CardIssuePointsApi
 */
export interface CardIssuePointsApiInterface {
	/**
	 * @summary Добавление нового пункта выдачи карт
	 * @param {Api.AddCardIssuePoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	cardIssuePointsAdd(ctx: Context, request: Api.AddCardIssuePoint, options?: HttpRequestOptionsInit): Promise<CardIssuePointsApi.CardIssuePointsAddResponse>

	/**
	 * @summary Удаление пункта выдачи карт
	 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	cardIssuePointsDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<CardIssuePointsApi.CardIssuePointsDeleteResponse>

	/**
	 * @summary Получение пункта выдачи карт по ID
	 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	cardIssuePointsGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<CardIssuePointsApi.CardIssuePointsGetByIdResponse>

	/**
	 * @summary Получение списка пунктов выдачи карт
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по адресу</p>
	 * @param {Api.CardIssuePointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.CardIssuePointsGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	cardIssuePointsGetList(ctx: Context, params: CardIssuePointsApi.CardIssuePointsGetListParameters, options?: HttpRequestOptionsInit): Promise<CardIssuePointsApi.CardIssuePointsGetListResponse>

	/**
	 * @summary Обновление пункта выдачи карт
	 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
	 * @param {Api.UpdateCardIssuePoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	cardIssuePointsUpdate(ctx: Context, id: string, request: Api.UpdateCardIssuePoint, options?: HttpRequestOptionsInit): Promise<CardIssuePointsApi.CardIssuePointsUpdateResponse>

}

/**
 * CardIssuePointsApi - object-oriented interface
 * @export
 * @class CardIssuePointsApi
 * @extends {BaseAPI}
 */
export class CardIssuePointsApi extends BaseAPI implements CardIssuePointsApiInterface {
	/**
	 * @summary Добавление нового пункта выдачи карт
	 * @param {Api.AddCardIssuePoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public cardIssuePointsAdd(ctx: Context, request: Api.AddCardIssuePoint, options?: HttpRequestOptionsInit) {
		return CardIssuePointsApiFp(this.configuration).cardIssuePointsAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Удаление пункта выдачи карт
	 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public cardIssuePointsDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return CardIssuePointsApiFp(this.configuration).cardIssuePointsDelete(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение пункта выдачи карт по ID
	 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public cardIssuePointsGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return CardIssuePointsApiFp(this.configuration).cardIssuePointsGetById(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение списка пунктов выдачи карт
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по адресу</p>
	 * @param {Api.CardIssuePointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.CardIssuePointsGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public cardIssuePointsGetList(ctx: Context, params: CardIssuePointsApi.CardIssuePointsGetListParameters, options?: HttpRequestOptionsInit) {
		return CardIssuePointsApiFp(this.configuration).cardIssuePointsGetList(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Обновление пункта выдачи карт
	 * @param {string} id <p>Идентификатор пункта выдачи карт</p>
	 * @param {Api.UpdateCardIssuePoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public cardIssuePointsUpdate(ctx: Context, id: string, request: Api.UpdateCardIssuePoint, options?: HttpRequestOptionsInit) {
		return CardIssuePointsApiFp(this.configuration).cardIssuePointsUpdate(ctx, id, request, options)(this.client, this.basePath);
	}

}
export namespace CitizenCategoriesApi {
	export type CitizenCategoriesGetObjectResponse =
		| CitizenCategoriesGetObject200Response
	
	export interface CitizenCategoriesGetObject200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CitizenCategoriesGetObject200Response
		headers?: undefined
	}
	
	export type CitizenCategoryUpdateResponse =
		| CitizenCategoryUpdate200Response
	
	export interface CitizenCategoryUpdate200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * CitizenCategoriesApi - request creator
 * @export
 */
export const CitizenCategoriesApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получение всех категорий граждан
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenCategoriesGetObject(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/citizen-categories/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Изменения коэффициента категории граждан
		 * @param {string} code <p>Код категори граждан</p>
		 * @param {Api.UpdateCitizenCategory} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenCategoryUpdate(ctx: Context, code: string, request: Api.UpdateCitizenCategory, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'code' is not null or undefined
			if (code === null || code === undefined) {
				throw new RequiredError('code', 'Required parameter code was null or undefined when calling citizenCategoryUpdate.');
			}
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling citizenCategoryUpdate.');
			}

			let localVarPath = `/api/v1/citizen-categories/{code}`
				.replace('{code}', encodeURIComponent(String(code)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'PATCH', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * CitizenCategoriesApi - functional programming interface
 * @export
 */
export const CitizenCategoriesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получение всех категорий граждан
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenCategoriesGetObject(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizenCategoriesApi.CitizenCategoriesGetObjectResponse> {
			const localVarHttpRequest = CitizenCategoriesApiHttpRequestCreator(configuration).citizenCategoriesGetObject(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CitizenCategoriesGetObject200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Изменения коэффициента категории граждан
		 * @param {string} code <p>Код категори граждан</p>
		 * @param {Api.UpdateCitizenCategory} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenCategoryUpdate(ctx: Context, code: string, request: Api.UpdateCitizenCategory, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizenCategoriesApi.CitizenCategoryUpdateResponse> {
			const localVarHttpRequest = CitizenCategoriesApiHttpRequestCreator(configuration).citizenCategoryUpdate(ctx, code, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * CitizenCategoriesApi - factory interface
 * @export
 */
export const CitizenCategoriesApiFactory: FactoryFunction<CitizenCategoriesApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new CitizenCategoriesApi(client, configuration, basePath);
};

/**
 * CitizenCategoriesApi - interface
 * @export
 * @interface CitizenCategoriesApi
 */
export interface CitizenCategoriesApiInterface {
	/**
	 * @summary Получение всех категорий граждан
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizenCategoriesGetObject(ctx: Context, options?: HttpRequestOptionsInit): Promise<CitizenCategoriesApi.CitizenCategoriesGetObjectResponse>

	/**
	 * @summary Изменения коэффициента категории граждан
	 * @param {string} code <p>Код категори граждан</p>
	 * @param {Api.UpdateCitizenCategory} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizenCategoryUpdate(ctx: Context, code: string, request: Api.UpdateCitizenCategory, options?: HttpRequestOptionsInit): Promise<CitizenCategoriesApi.CitizenCategoryUpdateResponse>

}

/**
 * CitizenCategoriesApi - object-oriented interface
 * @export
 * @class CitizenCategoriesApi
 * @extends {BaseAPI}
 */
export class CitizenCategoriesApi extends BaseAPI implements CitizenCategoriesApiInterface {
	/**
	 * @summary Получение всех категорий граждан
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizenCategoriesGetObject(ctx: Context, options?: HttpRequestOptionsInit) {
		return CitizenCategoriesApiFp(this.configuration).citizenCategoriesGetObject(ctx, options)(this.client, this.basePath);
	}

	/**
	 * @summary Изменения коэффициента категории граждан
	 * @param {string} code <p>Код категори граждан</p>
	 * @param {Api.UpdateCitizenCategory} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizenCategoryUpdate(ctx: Context, code: string, request: Api.UpdateCitizenCategory, options?: HttpRequestOptionsInit) {
		return CitizenCategoriesApiFp(this.configuration).citizenCategoryUpdate(ctx, code, request, options)(this.client, this.basePath);
	}

}
export namespace CitizensApi {
	export type CitizenDependentsAddResponse =
		| CitizenDependentsAdd200Response
	
	export interface CitizenDependentsAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
	export interface CitizenDependentsDeleteParameters {
		/**
		 * @description <p>Идентификатор опекуна</p>
		 * @type {string}
		 */
		guardianId: string
		/**
		 * @description <p>Идентификатор иждивенца</p>
		 * @type {string}
		 */
		dependentId: string
	}
	
	export type CitizenDependentsDeleteResponse =
		| CitizenDependentsDelete200Response
	
	export interface CitizenDependentsDelete200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
	export type CitizenDocumentsGetListByIdResponse =
		| CitizenDocumentsGetListById200Response
	
	export interface CitizenDocumentsGetListById200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CitizenDocumentsGetListById200Response
		headers?: undefined
	}
	
	export type CitizensAddResponse =
		| CitizensAdd200Response
	
	export interface CitizensAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CitizensAdd200Response
		headers?: undefined
	}
	
	export type CitizensDeleteResponse =
		| CitizensDelete200Response
	
	export interface CitizensDelete200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
	export type CitizensGetByIdResponse =
		| CitizensGetById200Response
	
	export interface CitizensGetById200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CitizensGetById200Response
		headers?: undefined
	}
	
	export interface CitizensGetListParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
		 * @type {string}
		 */
		search?: string
		/**
		 * @description <p>Фильтр по идентификатору МО</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.CitizensGetListOrderBy}
		 */
		orderBy?: Api.CitizensGetListOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.CitizensGetListDirection}
		 */
		direction?: Api.CitizensGetListDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type CitizensGetListResponse =
		| CitizensGetList200Response
	
	export interface CitizensGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CitizensGetList200Response
		headers?: undefined
	}
	
	export type CitizensUpdateResponse =
		| CitizensUpdate200Response
	
	export interface CitizensUpdate200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
	export interface CitizensWithInfoGetListParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
		 * @type {string}
		 */
		search?: string
		/**
		 * @description <p>Фильтр по идентификатору МО</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Фильтр по статусу карты</p>
		 * @type {Api.CitizensWithInfoGetListCardStatus}
		 */
		cardStatus?: Api.CitizensWithInfoGetListCardStatus
		/**
		 * @description <p>Фильтр по году выдачи карты</p>
		 * @type {number}
		 */
		month?: number
		/**
		 * @description <p>Фильтр по месяцу выдачи карты</p>
		 * @type {number}
		 */
		year?: number
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.CitizensWithInfoGetListOrderBy}
		 */
		orderBy?: Api.CitizensWithInfoGetListOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.CitizensWithInfoGetListDirection}
		 */
		direction?: Api.CitizensWithInfoGetListDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type CitizensWithInfoGetListResponse =
		| CitizensWithInfoGetList200Response
	
	export interface CitizensWithInfoGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.CitizensWithInfoGetList200Response
		headers?: undefined
	}
	
}

/**
 * CitizensApi - request creator
 * @export
 */
export const CitizensApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Создание связи между иждивенцем и опекуном
		 * @param {Api.CitizenDependentsAddRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenDependentsAdd(ctx: Context, request: Api.CitizenDependentsAddRequest, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling citizenDependentsAdd.');
			}

			let localVarPath = `/api/v1/citizens/dependents`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Удаление связи между иждивенцем и опекуном
		 * @param {string} guardianId <p>Идентификатор опекуна</p>
		 * @param {string} dependentId <p>Идентификатор иждивенца</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenDependentsDelete(ctx: Context, params: CitizensApi.CitizenDependentsDeleteParameters, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'guardianId' is not null or undefined
			if (params.guardianId === null || params.guardianId === undefined) {
				throw new RequiredError('guardianId', 'Required parameter guardianId was null or undefined when calling citizenDependentsDelete.');
			}
			// verify required parameter 'dependentId' is not null or undefined
			if (params.dependentId === null || params.dependentId === undefined) {
				throw new RequiredError('dependentId', 'Required parameter dependentId was null or undefined when calling citizenDependentsDelete.');
			}

			let localVarPath = `/api/v1/citizens/dependents`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'DELETE', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.guardianId !== undefined) {
				localVarQueryParameter.append('guardianId', String(params.guardianId));
			}

			if (params.dependentId !== undefined) {
				localVarQueryParameter.append('dependentId', String(params.dependentId));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение документов гражданина по ID
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenDocumentsGetListById(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling citizenDocumentsGetListById.');
			}

			let localVarPath = `/api/v1/citizens/{id}/documents`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Создание гражданина
		 * @param {Api.AddCitizen} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensAdd(ctx: Context, request: Api.AddCitizen, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling citizensAdd.');
			}

			let localVarPath = `/api/v1/citizens`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Удаление гражданина
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensDelete(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling citizensDelete.');
			}

			let localVarPath = `/api/v1/citizens/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'DELETE', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение гражданина по ID
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensGetById(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling citizensGetById.');
			}

			let localVarPath = `/api/v1/citizens/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение списка граждан
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
		 * @param {Api.CitizensGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.CitizensGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensGetList(ctx: Context, params: CitizensApi.CitizensGetListParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/citizens`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.search !== undefined) {
				localVarQueryParameter.append('search', String(params.search));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Обновление гражданина
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {Api.UpdateCitizen} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensUpdate(ctx: Context, id: string, request: Api.UpdateCitizen, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling citizensUpdate.');
			}
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling citizensUpdate.');
			}

			let localVarPath = `/api/v1/citizens/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'PATCH', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение списка граждан с документом
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
		 * @param {Api.CitizensWithInfoGetListCardStatus} [cardStatus] <p>Фильтр по статусу карты</p>
		 * @param {number} [month] <p>Фильтр по году выдачи карты</p>
		 * @param {number} [year] <p>Фильтр по месяцу выдачи карты</p>
		 * @param {Api.CitizensWithInfoGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.CitizensWithInfoGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensWithInfoGetList(ctx: Context, params: CitizensApi.CitizensWithInfoGetListParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/citizens/with-info`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.search !== undefined) {
				localVarQueryParameter.append('search', String(params.search));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.cardStatus !== undefined) {
				localVarQueryParameter.append('cardStatus', String(params.cardStatus));
			}

			if (params.month !== undefined) {
				localVarQueryParameter.append('month', String(params.month));
			}

			if (params.year !== undefined) {
				localVarQueryParameter.append('year', String(params.year));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * CitizensApi - functional programming interface
 * @export
 */
export const CitizensApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Создание связи между иждивенцем и опекуном
		 * @param {Api.CitizenDependentsAddRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenDependentsAdd(ctx: Context, request: Api.CitizenDependentsAddRequest, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizenDependentsAddResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizenDependentsAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Удаление связи между иждивенцем и опекуном
		 * @param {string} guardianId <p>Идентификатор опекуна</p>
		 * @param {string} dependentId <p>Идентификатор иждивенца</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenDependentsDelete(ctx: Context, params: CitizensApi.CitizenDependentsDeleteParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizenDependentsDeleteResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizenDependentsDelete(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение документов гражданина по ID
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizenDocumentsGetListById(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizenDocumentsGetListByIdResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizenDocumentsGetListById(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CitizenDocumentsGetListById200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Создание гражданина
		 * @param {Api.AddCitizen} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensAdd(ctx: Context, request: Api.AddCitizen, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizensAddResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizensAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CitizensAdd200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Удаление гражданина
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizensDeleteResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizensDelete(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение гражданина по ID
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizensGetByIdResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizensGetById(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CitizensGetById200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение списка граждан
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
		 * @param {Api.CitizensGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.CitizensGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensGetList(ctx: Context, params: CitizensApi.CitizensGetListParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizensGetListResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizensGetList(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CitizensGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Обновление гражданина
		 * @param {string} id <p>Идентификатор гражданина</p>
		 * @param {Api.UpdateCitizen} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensUpdate(ctx: Context, id: string, request: Api.UpdateCitizen, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizensUpdateResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizensUpdate(ctx, id, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение списка граждан с документом
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
		 * @param {Api.CitizensWithInfoGetListCardStatus} [cardStatus] <p>Фильтр по статусу карты</p>
		 * @param {number} [month] <p>Фильтр по году выдачи карты</p>
		 * @param {number} [year] <p>Фильтр по месяцу выдачи карты</p>
		 * @param {Api.CitizensWithInfoGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.CitizensWithInfoGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		citizensWithInfoGetList(ctx: Context, params: CitizensApi.CitizensWithInfoGetListParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<CitizensApi.CitizensWithInfoGetListResponse> {
			const localVarHttpRequest = CitizensApiHttpRequestCreator(configuration).citizensWithInfoGetList(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.CitizensWithInfoGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * CitizensApi - factory interface
 * @export
 */
export const CitizensApiFactory: FactoryFunction<CitizensApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new CitizensApi(client, configuration, basePath);
};

/**
 * CitizensApi - interface
 * @export
 * @interface CitizensApi
 */
export interface CitizensApiInterface {
	/**
	 * @summary Создание связи между иждивенцем и опекуном
	 * @param {Api.CitizenDependentsAddRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizenDependentsAdd(ctx: Context, request: Api.CitizenDependentsAddRequest, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizenDependentsAddResponse>

	/**
	 * @summary Удаление связи между иждивенцем и опекуном
	 * @param {string} guardianId <p>Идентификатор опекуна</p>
	 * @param {string} dependentId <p>Идентификатор иждивенца</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizenDependentsDelete(ctx: Context, params: CitizensApi.CitizenDependentsDeleteParameters, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizenDependentsDeleteResponse>

	/**
	 * @summary Получение документов гражданина по ID
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizenDocumentsGetListById(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizenDocumentsGetListByIdResponse>

	/**
	 * @summary Создание гражданина
	 * @param {Api.AddCitizen} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizensAdd(ctx: Context, request: Api.AddCitizen, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizensAddResponse>

	/**
	 * @summary Удаление гражданина
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizensDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizensDeleteResponse>

	/**
	 * @summary Получение гражданина по ID
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizensGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizensGetByIdResponse>

	/**
	 * @summary Получение списка граждан
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
	 * @param {Api.CitizensGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.CitizensGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizensGetList(ctx: Context, params: CitizensApi.CitizensGetListParameters, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizensGetListResponse>

	/**
	 * @summary Обновление гражданина
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {Api.UpdateCitizen} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizensUpdate(ctx: Context, id: string, request: Api.UpdateCitizen, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizensUpdateResponse>

	/**
	 * @summary Получение списка граждан с документом
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
	 * @param {Api.CitizensWithInfoGetListCardStatus} [cardStatus] <p>Фильтр по статусу карты</p>
	 * @param {number} [month] <p>Фильтр по году выдачи карты</p>
	 * @param {number} [year] <p>Фильтр по месяцу выдачи карты</p>
	 * @param {Api.CitizensWithInfoGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.CitizensWithInfoGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	citizensWithInfoGetList(ctx: Context, params: CitizensApi.CitizensWithInfoGetListParameters, options?: HttpRequestOptionsInit): Promise<CitizensApi.CitizensWithInfoGetListResponse>

}

/**
 * CitizensApi - object-oriented interface
 * @export
 * @class CitizensApi
 * @extends {BaseAPI}
 */
export class CitizensApi extends BaseAPI implements CitizensApiInterface {
	/**
	 * @summary Создание связи между иждивенцем и опекуном
	 * @param {Api.CitizenDependentsAddRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizenDependentsAdd(ctx: Context, request: Api.CitizenDependentsAddRequest, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizenDependentsAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Удаление связи между иждивенцем и опекуном
	 * @param {string} guardianId <p>Идентификатор опекуна</p>
	 * @param {string} dependentId <p>Идентификатор иждивенца</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizenDependentsDelete(ctx: Context, params: CitizensApi.CitizenDependentsDeleteParameters, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizenDependentsDelete(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение документов гражданина по ID
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizenDocumentsGetListById(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizenDocumentsGetListById(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Создание гражданина
	 * @param {Api.AddCitizen} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizensAdd(ctx: Context, request: Api.AddCitizen, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizensAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Удаление гражданина
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizensDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizensDelete(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение гражданина по ID
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizensGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizensGetById(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение списка граждан
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
	 * @param {Api.CitizensGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.CitizensGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizensGetList(ctx: Context, params: CitizensApi.CitizensGetListParameters, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizensGetList(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Обновление гражданина
	 * @param {string} id <p>Идентификатор гражданина</p>
	 * @param {Api.UpdateCitizen} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizensUpdate(ctx: Context, id: string, request: Api.UpdateCitizen, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizensUpdate(ctx, id, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение списка граждан с документом
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по фио, телефону, документу и адресу гражданина</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по идентификатору МО</p>
	 * @param {Api.CitizensWithInfoGetListCardStatus} [cardStatus] <p>Фильтр по статусу карты</p>
	 * @param {number} [month] <p>Фильтр по году выдачи карты</p>
	 * @param {number} [year] <p>Фильтр по месяцу выдачи карты</p>
	 * @param {Api.CitizensWithInfoGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.CitizensWithInfoGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public citizensWithInfoGetList(ctx: Context, params: CitizensApi.CitizensWithInfoGetListParameters, options?: HttpRequestOptionsInit) {
		return CitizensApiFp(this.configuration).citizensWithInfoGetList(ctx, params, options)(this.client, this.basePath);
	}

}
export namespace ConsumptionRatesApi {
	export type ConsumptionRatesGetObjectResponse =
		| ConsumptionRatesGetObject200Response
	
	export interface ConsumptionRatesGetObject200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ConsumptionRatesGetObject200Response
		headers?: undefined
	}
	
	export type ConsumptionRatesUpdateResponse =
		| ConsumptionRatesUpdate200Response
	
	export interface ConsumptionRatesUpdate200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * ConsumptionRatesApi - request creator
 * @export
 */
export const ConsumptionRatesApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получить все нормы потребления
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		consumptionRatesGetObject(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/consumption-rates/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Обновление нормы потребления
		 * @param {Api.ConsumptionRatesUpdateProductCategory} productCategory <p>Категория товара</p>
		 * @param {Api.UpdateConsumptionRate} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		consumptionRatesUpdate(ctx: Context, productCategory: Api.ConsumptionRatesUpdateProductCategory, request: Api.UpdateConsumptionRate, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'productCategory' is not null or undefined
			if (productCategory === null || productCategory === undefined) {
				throw new RequiredError('productCategory', 'Required parameter productCategory was null or undefined when calling consumptionRatesUpdate.');
			}
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling consumptionRatesUpdate.');
			}

			let localVarPath = `/api/v1/consumption-rates/{productCategory}`
				.replace('{productCategory}', encodeURIComponent(String(productCategory)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'PATCH', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * ConsumptionRatesApi - functional programming interface
 * @export
 */
export const ConsumptionRatesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получить все нормы потребления
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		consumptionRatesGetObject(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ConsumptionRatesApi.ConsumptionRatesGetObjectResponse> {
			const localVarHttpRequest = ConsumptionRatesApiHttpRequestCreator(configuration).consumptionRatesGetObject(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ConsumptionRatesGetObject200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Обновление нормы потребления
		 * @param {Api.ConsumptionRatesUpdateProductCategory} productCategory <p>Категория товара</p>
		 * @param {Api.UpdateConsumptionRate} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		consumptionRatesUpdate(ctx: Context, productCategory: Api.ConsumptionRatesUpdateProductCategory, request: Api.UpdateConsumptionRate, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ConsumptionRatesApi.ConsumptionRatesUpdateResponse> {
			const localVarHttpRequest = ConsumptionRatesApiHttpRequestCreator(configuration).consumptionRatesUpdate(ctx, productCategory, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * ConsumptionRatesApi - factory interface
 * @export
 */
export const ConsumptionRatesApiFactory: FactoryFunction<ConsumptionRatesApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new ConsumptionRatesApi(client, configuration, basePath);
};

/**
 * ConsumptionRatesApi - interface
 * @export
 * @interface ConsumptionRatesApi
 */
export interface ConsumptionRatesApiInterface {
	/**
	 * @summary Получить все нормы потребления
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	consumptionRatesGetObject(ctx: Context, options?: HttpRequestOptionsInit): Promise<ConsumptionRatesApi.ConsumptionRatesGetObjectResponse>

	/**
	 * @summary Обновление нормы потребления
	 * @param {Api.ConsumptionRatesUpdateProductCategory} productCategory <p>Категория товара</p>
	 * @param {Api.UpdateConsumptionRate} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	consumptionRatesUpdate(ctx: Context, productCategory: Api.ConsumptionRatesUpdateProductCategory, request: Api.UpdateConsumptionRate, options?: HttpRequestOptionsInit): Promise<ConsumptionRatesApi.ConsumptionRatesUpdateResponse>

}

/**
 * ConsumptionRatesApi - object-oriented interface
 * @export
 * @class ConsumptionRatesApi
 * @extends {BaseAPI}
 */
export class ConsumptionRatesApi extends BaseAPI implements ConsumptionRatesApiInterface {
	/**
	 * @summary Получить все нормы потребления
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public consumptionRatesGetObject(ctx: Context, options?: HttpRequestOptionsInit) {
		return ConsumptionRatesApiFp(this.configuration).consumptionRatesGetObject(ctx, options)(this.client, this.basePath);
	}

	/**
	 * @summary Обновление нормы потребления
	 * @param {Api.ConsumptionRatesUpdateProductCategory} productCategory <p>Категория товара</p>
	 * @param {Api.UpdateConsumptionRate} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public consumptionRatesUpdate(ctx: Context, productCategory: Api.ConsumptionRatesUpdateProductCategory, request: Api.UpdateConsumptionRate, options?: HttpRequestOptionsInit) {
		return ConsumptionRatesApiFp(this.configuration).consumptionRatesUpdate(ctx, productCategory, request, options)(this.client, this.basePath);
	}

}
export namespace ConsumptionStandardsApi {
	export type ConsumptionStandardsGetObjectResponse =
		| ConsumptionStandardsGetObject200Response
	
	export interface ConsumptionStandardsGetObject200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ConsumptionStandardsGetObject200Response
		headers?: undefined
	}
	
}

/**
 * ConsumptionStandardsApi - request creator
 * @export
 */
export const ConsumptionStandardsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получить нормативы на талоны для всех категорий граждан
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		consumptionStandardsGetObject(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/consumption-standards/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * ConsumptionStandardsApi - functional programming interface
 * @export
 */
export const ConsumptionStandardsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получить нормативы на талоны для всех категорий граждан
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		consumptionStandardsGetObject(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ConsumptionStandardsApi.ConsumptionStandardsGetObjectResponse> {
			const localVarHttpRequest = ConsumptionStandardsApiHttpRequestCreator(configuration).consumptionStandardsGetObject(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ConsumptionStandardsGetObject200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * ConsumptionStandardsApi - factory interface
 * @export
 */
export const ConsumptionStandardsApiFactory: FactoryFunction<ConsumptionStandardsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new ConsumptionStandardsApi(client, configuration, basePath);
};

/**
 * ConsumptionStandardsApi - interface
 * @export
 * @interface ConsumptionStandardsApi
 */
export interface ConsumptionStandardsApiInterface {
	/**
	 * @summary Получить нормативы на талоны для всех категорий граждан
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	consumptionStandardsGetObject(ctx: Context, options?: HttpRequestOptionsInit): Promise<ConsumptionStandardsApi.ConsumptionStandardsGetObjectResponse>

}

/**
 * ConsumptionStandardsApi - object-oriented interface
 * @export
 * @class ConsumptionStandardsApi
 * @extends {BaseAPI}
 */
export class ConsumptionStandardsApi extends BaseAPI implements ConsumptionStandardsApiInterface {
	/**
	 * @summary Получить нормативы на талоны для всех категорий граждан
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public consumptionStandardsGetObject(ctx: Context, options?: HttpRequestOptionsInit) {
		return ConsumptionStandardsApiFp(this.configuration).consumptionStandardsGetObject(ctx, options)(this.client, this.basePath);
	}

}
export namespace GlobalSettingsApi {
	export type GlobalSettingsGetObjectResponse =
		| GlobalSettingsGetObject200Response
	
	export interface GlobalSettingsGetObject200Response {
		status: 200
		contentType: 'application/json'
		body: Api.GlobalSettingsGetObject200Response
		headers?: undefined
	}
	
	export type GlobalSettingsUpdateResponse =
		| GlobalSettingsUpdate200Response
	
	export interface GlobalSettingsUpdate200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * GlobalSettingsApi - request creator
 * @export
 */
export const GlobalSettingsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получение всех системных настроек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		globalSettingsGetObject(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/global-settings/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Обновление системных настроек
		 * @param {Api.UpdateGlobalSettings} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		globalSettingsUpdate(ctx: Context, request: Api.UpdateGlobalSettings, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling globalSettingsUpdate.');
			}

			let localVarPath = `/api/v1/global-settings/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'PATCH', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * GlobalSettingsApi - functional programming interface
 * @export
 */
export const GlobalSettingsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получение всех системных настроек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		globalSettingsGetObject(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<GlobalSettingsApi.GlobalSettingsGetObjectResponse> {
			const localVarHttpRequest = GlobalSettingsApiHttpRequestCreator(configuration).globalSettingsGetObject(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.GlobalSettingsGetObject200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Обновление системных настроек
		 * @param {Api.UpdateGlobalSettings} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		globalSettingsUpdate(ctx: Context, request: Api.UpdateGlobalSettings, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<GlobalSettingsApi.GlobalSettingsUpdateResponse> {
			const localVarHttpRequest = GlobalSettingsApiHttpRequestCreator(configuration).globalSettingsUpdate(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * GlobalSettingsApi - factory interface
 * @export
 */
export const GlobalSettingsApiFactory: FactoryFunction<GlobalSettingsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new GlobalSettingsApi(client, configuration, basePath);
};

/**
 * GlobalSettingsApi - interface
 * @export
 * @interface GlobalSettingsApi
 */
export interface GlobalSettingsApiInterface {
	/**
	 * @summary Получение всех системных настроек
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	globalSettingsGetObject(ctx: Context, options?: HttpRequestOptionsInit): Promise<GlobalSettingsApi.GlobalSettingsGetObjectResponse>

	/**
	 * @summary Обновление системных настроек
	 * @param {Api.UpdateGlobalSettings} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	globalSettingsUpdate(ctx: Context, request: Api.UpdateGlobalSettings, options?: HttpRequestOptionsInit): Promise<GlobalSettingsApi.GlobalSettingsUpdateResponse>

}

/**
 * GlobalSettingsApi - object-oriented interface
 * @export
 * @class GlobalSettingsApi
 * @extends {BaseAPI}
 */
export class GlobalSettingsApi extends BaseAPI implements GlobalSettingsApiInterface {
	/**
	 * @summary Получение всех системных настроек
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public globalSettingsGetObject(ctx: Context, options?: HttpRequestOptionsInit) {
		return GlobalSettingsApiFp(this.configuration).globalSettingsGetObject(ctx, options)(this.client, this.basePath);
	}

	/**
	 * @summary Обновление системных настроек
	 * @param {Api.UpdateGlobalSettings} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public globalSettingsUpdate(ctx: Context, request: Api.UpdateGlobalSettings, options?: HttpRequestOptionsInit) {
		return GlobalSettingsApiFp(this.configuration).globalSettingsUpdate(ctx, request, options)(this.client, this.basePath);
	}

}
export namespace IdentityCardsApi {
	export type IdentityCardsConfirmResponse =
		| IdentityCardsConfirm200Response
	
	export interface IdentityCardsConfirm200Response {
		status: 200
		contentType: 'application/json'
		body: Api.IdentityCardsConfirm200Response
		headers?: undefined
	}
	
	export type IdentityCardsGetListByCitizenIdResponse =
		| IdentityCardsGetListByCitizenId200Response
	
	export interface IdentityCardsGetListByCitizenId200Response {
		status: 200
		contentType: 'application/json'
		body: Api.IdentityCardsGetListByCitizenId200Response
		headers?: undefined
	}
	
	export type IdentityCardsPrintResponse =
		| IdentityCardsPrint200Response
	
	export interface IdentityCardsPrint200Response {
		status: 200
		contentType: 'application/json'
		body: Api.IdentityCardsPrint200Response
		headers?: undefined
	}
	
}

/**
 * IdentityCardsApi - request creator
 * @export
 */
export const IdentityCardsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Выдача идентификационной карточки гражданину
		 * @param {Api.ConfirmDataForIdentityCard} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		identityCardsConfirm(ctx: Context, request: Api.ConfirmDataForIdentityCard, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling identityCardsConfirm.');
			}

			let localVarPath = `/api/v1/citizens/identity-cards/confirm`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получить список карточек гражданина
		 * @param {string} citizenId <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		identityCardsGetListByCitizenId(ctx: Context, citizenId: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'citizenId' is not null or undefined
			if (citizenId === null || citizenId === undefined) {
				throw new RequiredError('citizenId', 'Required parameter citizenId was null or undefined when calling identityCardsGetListByCitizenId.');
			}

			let localVarPath = `/api/v1/citizens/identity-cards/{citizenId}`
				.replace('{citizenId}', encodeURIComponent(String(citizenId)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Печать идентификационной карты
		 * @param {Api.PrintableDataForIdentityCard} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		identityCardsPrint(ctx: Context, request: Api.PrintableDataForIdentityCard, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling identityCardsPrint.');
			}

			let localVarPath = `/api/v1/citizens/identity-cards/print`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * IdentityCardsApi - functional programming interface
 * @export
 */
export const IdentityCardsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Выдача идентификационной карточки гражданину
		 * @param {Api.ConfirmDataForIdentityCard} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		identityCardsConfirm(ctx: Context, request: Api.ConfirmDataForIdentityCard, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<IdentityCardsApi.IdentityCardsConfirmResponse> {
			const localVarHttpRequest = IdentityCardsApiHttpRequestCreator(configuration).identityCardsConfirm(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.IdentityCardsConfirm200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получить список карточек гражданина
		 * @param {string} citizenId <p>Идентификатор гражданина</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		identityCardsGetListByCitizenId(ctx: Context, citizenId: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<IdentityCardsApi.IdentityCardsGetListByCitizenIdResponse> {
			const localVarHttpRequest = IdentityCardsApiHttpRequestCreator(configuration).identityCardsGetListByCitizenId(ctx, citizenId, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.IdentityCardsGetListByCitizenId200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Печать идентификационной карты
		 * @param {Api.PrintableDataForIdentityCard} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		identityCardsPrint(ctx: Context, request: Api.PrintableDataForIdentityCard, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<IdentityCardsApi.IdentityCardsPrintResponse> {
			const localVarHttpRequest = IdentityCardsApiHttpRequestCreator(configuration).identityCardsPrint(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.IdentityCardsPrint200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * IdentityCardsApi - factory interface
 * @export
 */
export const IdentityCardsApiFactory: FactoryFunction<IdentityCardsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new IdentityCardsApi(client, configuration, basePath);
};

/**
 * IdentityCardsApi - interface
 * @export
 * @interface IdentityCardsApi
 */
export interface IdentityCardsApiInterface {
	/**
	 * @summary Выдача идентификационной карточки гражданину
	 * @param {Api.ConfirmDataForIdentityCard} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	identityCardsConfirm(ctx: Context, request: Api.ConfirmDataForIdentityCard, options?: HttpRequestOptionsInit): Promise<IdentityCardsApi.IdentityCardsConfirmResponse>

	/**
	 * @summary Получить список карточек гражданина
	 * @param {string} citizenId <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	identityCardsGetListByCitizenId(ctx: Context, citizenId: string, options?: HttpRequestOptionsInit): Promise<IdentityCardsApi.IdentityCardsGetListByCitizenIdResponse>

	/**
	 * @summary Печать идентификационной карты
	 * @param {Api.PrintableDataForIdentityCard} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	identityCardsPrint(ctx: Context, request: Api.PrintableDataForIdentityCard, options?: HttpRequestOptionsInit): Promise<IdentityCardsApi.IdentityCardsPrintResponse>

}

/**
 * IdentityCardsApi - object-oriented interface
 * @export
 * @class IdentityCardsApi
 * @extends {BaseAPI}
 */
export class IdentityCardsApi extends BaseAPI implements IdentityCardsApiInterface {
	/**
	 * @summary Выдача идентификационной карточки гражданину
	 * @param {Api.ConfirmDataForIdentityCard} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public identityCardsConfirm(ctx: Context, request: Api.ConfirmDataForIdentityCard, options?: HttpRequestOptionsInit) {
		return IdentityCardsApiFp(this.configuration).identityCardsConfirm(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получить список карточек гражданина
	 * @param {string} citizenId <p>Идентификатор гражданина</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public identityCardsGetListByCitizenId(ctx: Context, citizenId: string, options?: HttpRequestOptionsInit) {
		return IdentityCardsApiFp(this.configuration).identityCardsGetListByCitizenId(ctx, citizenId, options)(this.client, this.basePath);
	}

	/**
	 * @summary Печать идентификационной карты
	 * @param {Api.PrintableDataForIdentityCard} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public identityCardsPrint(ctx: Context, request: Api.PrintableDataForIdentityCard, options?: HttpRequestOptionsInit) {
		return IdentityCardsApiFp(this.configuration).identityCardsPrint(ctx, request, options)(this.client, this.basePath);
	}

}
export namespace IssuanceCardsStatsApi {
	export interface IssuanceCardsStatsFormReportParameters {
		/**
		 * @description <p>Фильтр по ID муниципального образования</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Фильтр по ID пункта выдачи карт</p>
		 * @type {string}
		 */
		cardIssuePointId?: string
		/**
		 * @description <p>Фильтр по месяцу</p>
		 * @type {number}
		 * minimum: 0
		 * maximum: 11
		 */
		month?: number
		/**
		 * @description <p>Фильтр по году</p>
		 * @type {number}
		 * minimum: 2022
		 */
		year?: number
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type IssuanceCardsStatsFormReportResponse =
		| IssuanceCardsStatsFormReport200Response
	
	export interface IssuanceCardsStatsFormReport200Response {
		status: 200
		contentType: 'application/json'
		body: Api.IssuanceCardsStatsFormReport200Response
		headers?: undefined
	}
	
}

/**
 * IssuanceCardsStatsApi - request creator
 * @export
 */
export const IssuanceCardsStatsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получить отчёт о выданных идентификационных картах
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
		 * @param {number} [month] <p>Фильтр по месяцу</p>
		 * @param {number} [year] <p>Фильтр по году</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		issuanceCardsStatsFormReport(ctx: Context, params: IssuanceCardsStatsApi.IssuanceCardsStatsFormReportParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/issuance-cards-stats/form-report`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.cardIssuePointId !== undefined) {
				localVarQueryParameter.append('cardIssuePointId', String(params.cardIssuePointId));
			}

			if (params.month !== undefined) {
				localVarQueryParameter.append('month', String(params.month));
			}

			if (params.year !== undefined) {
				localVarQueryParameter.append('year', String(params.year));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * IssuanceCardsStatsApi - functional programming interface
 * @export
 */
export const IssuanceCardsStatsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получить отчёт о выданных идентификационных картах
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
		 * @param {number} [month] <p>Фильтр по месяцу</p>
		 * @param {number} [year] <p>Фильтр по году</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		issuanceCardsStatsFormReport(ctx: Context, params: IssuanceCardsStatsApi.IssuanceCardsStatsFormReportParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<IssuanceCardsStatsApi.IssuanceCardsStatsFormReportResponse> {
			const localVarHttpRequest = IssuanceCardsStatsApiHttpRequestCreator(configuration).issuanceCardsStatsFormReport(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.IssuanceCardsStatsFormReport200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * IssuanceCardsStatsApi - factory interface
 * @export
 */
export const IssuanceCardsStatsApiFactory: FactoryFunction<IssuanceCardsStatsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new IssuanceCardsStatsApi(client, configuration, basePath);
};

/**
 * IssuanceCardsStatsApi - interface
 * @export
 * @interface IssuanceCardsStatsApi
 */
export interface IssuanceCardsStatsApiInterface {
	/**
	 * @summary Получить отчёт о выданных идентификационных картах
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
	 * @param {number} [month] <p>Фильтр по месяцу</p>
	 * @param {number} [year] <p>Фильтр по году</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	issuanceCardsStatsFormReport(ctx: Context, params: IssuanceCardsStatsApi.IssuanceCardsStatsFormReportParameters, options?: HttpRequestOptionsInit): Promise<IssuanceCardsStatsApi.IssuanceCardsStatsFormReportResponse>

}

/**
 * IssuanceCardsStatsApi - object-oriented interface
 * @export
 * @class IssuanceCardsStatsApi
 * @extends {BaseAPI}
 */
export class IssuanceCardsStatsApi extends BaseAPI implements IssuanceCardsStatsApiInterface {
	/**
	 * @summary Получить отчёт о выданных идентификационных картах
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
	 * @param {number} [month] <p>Фильтр по месяцу</p>
	 * @param {number} [year] <p>Фильтр по году</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public issuanceCardsStatsFormReport(ctx: Context, params: IssuanceCardsStatsApi.IssuanceCardsStatsFormReportParameters, options?: HttpRequestOptionsInit) {
		return IssuanceCardsStatsApiFp(this.configuration).issuanceCardsStatsFormReport(ctx, params, options)(this.client, this.basePath);
	}

}
export namespace MunicipalEntitiesApi {
	export type MunicipalEntityGetByIdResponse =
		| MunicipalEntityGetById200Response
	
	export interface MunicipalEntityGetById200Response {
		status: 200
		contentType: 'application/json'
		body: Api.MunicipalEntityGetById200Response
		headers?: undefined
	}
	
	export interface MunicipalEntityGetListParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Полнотекстовый фильтр по названию муниципального образования</p>
		 * @type {string}
		 */
		search?: string
		/**
		 * @description <p>Фильтр по индексу МО</p>
		 * @type {number}
		 */
		index?: number
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.MunicipalEntityGetListOrderBy}
		 */
		orderBy?: Api.MunicipalEntityGetListOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.MunicipalEntityGetListDirection}
		 */
		direction?: Api.MunicipalEntityGetListDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type MunicipalEntityGetListResponse =
		| MunicipalEntityGetList200Response
	
	export interface MunicipalEntityGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.MunicipalEntityGetList200Response
		headers?: undefined
	}
	
}

/**
 * MunicipalEntitiesApi - request creator
 * @export
 */
export const MunicipalEntitiesApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получение муниципального образования по ID
		 * @param {string} id <p>Идентификатор муниципального образования</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		municipalEntityGetById(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling municipalEntityGetById.');
			}

			let localVarPath = `/api/v1/municipal-entities/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение списка муниципальных образований
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по названию муниципального образования</p>
		 * @param {number} [index] <p>Фильтр по индексу МО</p>
		 * @param {Api.MunicipalEntityGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.MunicipalEntityGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		municipalEntityGetList(ctx: Context, params: MunicipalEntitiesApi.MunicipalEntityGetListParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/municipal-entities/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.search !== undefined) {
				localVarQueryParameter.append('search', String(params.search));
			}

			if (params.index !== undefined) {
				localVarQueryParameter.append('index', String(params.index));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * MunicipalEntitiesApi - functional programming interface
 * @export
 */
export const MunicipalEntitiesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получение муниципального образования по ID
		 * @param {string} id <p>Идентификатор муниципального образования</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		municipalEntityGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<MunicipalEntitiesApi.MunicipalEntityGetByIdResponse> {
			const localVarHttpRequest = MunicipalEntitiesApiHttpRequestCreator(configuration).municipalEntityGetById(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.MunicipalEntityGetById200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение списка муниципальных образований
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по названию муниципального образования</p>
		 * @param {number} [index] <p>Фильтр по индексу МО</p>
		 * @param {Api.MunicipalEntityGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.MunicipalEntityGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		municipalEntityGetList(ctx: Context, params: MunicipalEntitiesApi.MunicipalEntityGetListParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<MunicipalEntitiesApi.MunicipalEntityGetListResponse> {
			const localVarHttpRequest = MunicipalEntitiesApiHttpRequestCreator(configuration).municipalEntityGetList(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.MunicipalEntityGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * MunicipalEntitiesApi - factory interface
 * @export
 */
export const MunicipalEntitiesApiFactory: FactoryFunction<MunicipalEntitiesApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new MunicipalEntitiesApi(client, configuration, basePath);
};

/**
 * MunicipalEntitiesApi - interface
 * @export
 * @interface MunicipalEntitiesApi
 */
export interface MunicipalEntitiesApiInterface {
	/**
	 * @summary Получение муниципального образования по ID
	 * @param {string} id <p>Идентификатор муниципального образования</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	municipalEntityGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<MunicipalEntitiesApi.MunicipalEntityGetByIdResponse>

	/**
	 * @summary Получение списка муниципальных образований
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по названию муниципального образования</p>
	 * @param {number} [index] <p>Фильтр по индексу МО</p>
	 * @param {Api.MunicipalEntityGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.MunicipalEntityGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	municipalEntityGetList(ctx: Context, params: MunicipalEntitiesApi.MunicipalEntityGetListParameters, options?: HttpRequestOptionsInit): Promise<MunicipalEntitiesApi.MunicipalEntityGetListResponse>

}

/**
 * MunicipalEntitiesApi - object-oriented interface
 * @export
 * @class MunicipalEntitiesApi
 * @extends {BaseAPI}
 */
export class MunicipalEntitiesApi extends BaseAPI implements MunicipalEntitiesApiInterface {
	/**
	 * @summary Получение муниципального образования по ID
	 * @param {string} id <p>Идентификатор муниципального образования</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public municipalEntityGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return MunicipalEntitiesApiFp(this.configuration).municipalEntityGetById(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение списка муниципальных образований
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по названию муниципального образования</p>
	 * @param {number} [index] <p>Фильтр по индексу МО</p>
	 * @param {Api.MunicipalEntityGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.MunicipalEntityGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public municipalEntityGetList(ctx: Context, params: MunicipalEntitiesApi.MunicipalEntityGetListParameters, options?: HttpRequestOptionsInit) {
		return MunicipalEntitiesApiFp(this.configuration).municipalEntityGetList(ctx, params, options)(this.client, this.basePath);
	}

}
export namespace OtherApi {
	export type HealthcheckResponse =
		| Healthcheck200Response
	
	export interface Healthcheck200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * OtherApi - request creator
 * @export
 */
export const OtherApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Проверка состояния сервера
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		healthcheck(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/healthcheck`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * OtherApi - functional programming interface
 * @export
 */
export const OtherApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Проверка состояния сервера
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		healthcheck(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<OtherApi.HealthcheckResponse> {
			const localVarHttpRequest = OtherApiHttpRequestCreator(configuration).healthcheck(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * OtherApi - factory interface
 * @export
 */
export const OtherApiFactory: FactoryFunction<OtherApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new OtherApi(client, configuration, basePath);
};

/**
 * OtherApi - interface
 * @export
 * @interface OtherApi
 */
export interface OtherApiInterface {
	/**
	 * @summary Проверка состояния сервера
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	healthcheck(ctx: Context, options?: HttpRequestOptionsInit): Promise<OtherApi.HealthcheckResponse>

}

/**
 * OtherApi - object-oriented interface
 * @export
 * @class OtherApi
 * @extends {BaseAPI}
 */
export class OtherApi extends BaseAPI implements OtherApiInterface {
	/**
	 * @summary Проверка состояния сервера
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public healthcheck(ctx: Context, options?: HttpRequestOptionsInit) {
		return OtherApiFp(this.configuration).healthcheck(ctx, options)(this.client, this.basePath);
	}

}
export namespace ProductSuppliesApi {
	export type ProductSuppliesAddResponse =
		| ProductSuppliesAdd200Response
	
	export interface ProductSuppliesAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ProductSuppliesAdd200Response
		headers?: undefined
	}
	
	export interface ProductSuppliesFormReportParameters {
		/**
		 * @description <p>Фильтр по месяцу</p>
		 * @type {number}
		 * minimum: 0
		 * maximum: 11
		 */
		month?: number
		/**
		 * @description <p>Фильтр по году</p>
		 * @type {number}
		 * minimum: 2022
		 */
		year?: number
	}
	
	export type ProductSuppliesFormReportResponse =
		| ProductSuppliesFormReport200Response
	
	export interface ProductSuppliesFormReport200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ProductSuppliesFormReport200Response
		headers?: undefined
	}
	
	export interface ProductSuppliesGetListParameters {
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type ProductSuppliesGetListResponse =
		| ProductSuppliesGetList200Response
	
	export interface ProductSuppliesGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ProductSuppliesGetList200Response
		headers?: undefined
	}
	
}

/**
 * ProductSuppliesApi - request creator
 * @export
 */
export const ProductSuppliesApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление новой записи о поставке
		 * @param {Api.AddProductSupply} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		productSuppliesAdd(ctx: Context, request: Api.AddProductSupply, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling productSuppliesAdd.');
			}

			let localVarPath = `/api/v1/product-supplies/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение продовольственного плана
		 * @param {number} [month] <p>Фильтр по месяцу</p>
		 * @param {number} [year] <p>Фильтр по году</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		productSuppliesFormReport(ctx: Context, params: ProductSuppliesApi.ProductSuppliesFormReportParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/product-supplies/form-report`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.month !== undefined) {
				localVarQueryParameter.append('month', String(params.month));
			}

			if (params.year !== undefined) {
				localVarQueryParameter.append('year', String(params.year));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение списка записей о поставке
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		productSuppliesGetList(ctx: Context, params: ProductSuppliesApi.ProductSuppliesGetListParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/product-supplies/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * ProductSuppliesApi - functional programming interface
 * @export
 */
export const ProductSuppliesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление новой записи о поставке
		 * @param {Api.AddProductSupply} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		productSuppliesAdd(ctx: Context, request: Api.AddProductSupply, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ProductSuppliesApi.ProductSuppliesAddResponse> {
			const localVarHttpRequest = ProductSuppliesApiHttpRequestCreator(configuration).productSuppliesAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ProductSuppliesAdd200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение продовольственного плана
		 * @param {number} [month] <p>Фильтр по месяцу</p>
		 * @param {number} [year] <p>Фильтр по году</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		productSuppliesFormReport(ctx: Context, params: ProductSuppliesApi.ProductSuppliesFormReportParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ProductSuppliesApi.ProductSuppliesFormReportResponse> {
			const localVarHttpRequest = ProductSuppliesApiHttpRequestCreator(configuration).productSuppliesFormReport(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ProductSuppliesFormReport200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение списка записей о поставке
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		productSuppliesGetList(ctx: Context, params: ProductSuppliesApi.ProductSuppliesGetListParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<ProductSuppliesApi.ProductSuppliesGetListResponse> {
			const localVarHttpRequest = ProductSuppliesApiHttpRequestCreator(configuration).productSuppliesGetList(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ProductSuppliesGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * ProductSuppliesApi - factory interface
 * @export
 */
export const ProductSuppliesApiFactory: FactoryFunction<ProductSuppliesApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new ProductSuppliesApi(client, configuration, basePath);
};

/**
 * ProductSuppliesApi - interface
 * @export
 * @interface ProductSuppliesApi
 */
export interface ProductSuppliesApiInterface {
	/**
	 * @summary Добавление новой записи о поставке
	 * @param {Api.AddProductSupply} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	productSuppliesAdd(ctx: Context, request: Api.AddProductSupply, options?: HttpRequestOptionsInit): Promise<ProductSuppliesApi.ProductSuppliesAddResponse>

	/**
	 * @summary Получение продовольственного плана
	 * @param {number} [month] <p>Фильтр по месяцу</p>
	 * @param {number} [year] <p>Фильтр по году</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	productSuppliesFormReport(ctx: Context, params: ProductSuppliesApi.ProductSuppliesFormReportParameters, options?: HttpRequestOptionsInit): Promise<ProductSuppliesApi.ProductSuppliesFormReportResponse>

	/**
	 * @summary Получение списка записей о поставке
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	productSuppliesGetList(ctx: Context, params: ProductSuppliesApi.ProductSuppliesGetListParameters, options?: HttpRequestOptionsInit): Promise<ProductSuppliesApi.ProductSuppliesGetListResponse>

}

/**
 * ProductSuppliesApi - object-oriented interface
 * @export
 * @class ProductSuppliesApi
 * @extends {BaseAPI}
 */
export class ProductSuppliesApi extends BaseAPI implements ProductSuppliesApiInterface {
	/**
	 * @summary Добавление новой записи о поставке
	 * @param {Api.AddProductSupply} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public productSuppliesAdd(ctx: Context, request: Api.AddProductSupply, options?: HttpRequestOptionsInit) {
		return ProductSuppliesApiFp(this.configuration).productSuppliesAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение продовольственного плана
	 * @param {number} [month] <p>Фильтр по месяцу</p>
	 * @param {number} [year] <p>Фильтр по году</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public productSuppliesFormReport(ctx: Context, params: ProductSuppliesApi.ProductSuppliesFormReportParameters, options?: HttpRequestOptionsInit) {
		return ProductSuppliesApiFp(this.configuration).productSuppliesFormReport(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение списка записей о поставке
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public productSuppliesGetList(ctx: Context, params: ProductSuppliesApi.ProductSuppliesGetListParameters, options?: HttpRequestOptionsInit) {
		return ProductSuppliesApiFp(this.configuration).productSuppliesGetList(ctx, params, options)(this.client, this.basePath);
	}

}
export namespace RegistrationApi {
	export type RegistrationCheckCodeResponse =
		| RegistrationCheckCode200Response
	
	export interface RegistrationCheckCode200Response {
		status: 200
		contentType: 'application/json'
		body: Api.RegistrationCheckCode200Response
		headers?: undefined
	}
	
	export type RegistrationGenerateCodeResponse =
		| RegistrationGenerateCode200Response
	
	export interface RegistrationGenerateCode200Response {
		status: 200
		contentType: 'application/json'
		body: Api.RegistrationGenerateCode200Response
		headers?: undefined
	}
	
	export type RegistrationSelfRegisterResponse =
		| RegistrationSelfRegister200Response
	
	export interface RegistrationSelfRegister200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * RegistrationApi - request creator
 * @export
 */
export const RegistrationApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Проверка регистрационного кода
		 * @param {Api.RegistrationCheckCodeRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		registrationCheckCode(ctx: Context, request: Api.RegistrationCheckCodeRequest, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling registrationCheckCode.');
			}

			let localVarPath = `/api/v1/registration/check-code`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Генерация кода саморегистрации оператора
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		registrationGenerateCode(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/registration/generate-code`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Саморегистрация по коду
		 * @param {Api.RegistrationSelfRegisterRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		registrationSelfRegister(ctx: Context, request: Api.RegistrationSelfRegisterRequest, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling registrationSelfRegister.');
			}

			let localVarPath = `/api/v1/registration/self-register`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * RegistrationApi - functional programming interface
 * @export
 */
export const RegistrationApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Проверка регистрационного кода
		 * @param {Api.RegistrationCheckCodeRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		registrationCheckCode(ctx: Context, request: Api.RegistrationCheckCodeRequest, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<RegistrationApi.RegistrationCheckCodeResponse> {
			const localVarHttpRequest = RegistrationApiHttpRequestCreator(configuration).registrationCheckCode(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.RegistrationCheckCode200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Генерация кода саморегистрации оператора
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		registrationGenerateCode(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<RegistrationApi.RegistrationGenerateCodeResponse> {
			const localVarHttpRequest = RegistrationApiHttpRequestCreator(configuration).registrationGenerateCode(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.RegistrationGenerateCode200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Саморегистрация по коду
		 * @param {Api.RegistrationSelfRegisterRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		registrationSelfRegister(ctx: Context, request: Api.RegistrationSelfRegisterRequest, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<RegistrationApi.RegistrationSelfRegisterResponse> {
			const localVarHttpRequest = RegistrationApiHttpRequestCreator(configuration).registrationSelfRegister(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * RegistrationApi - factory interface
 * @export
 */
export const RegistrationApiFactory: FactoryFunction<RegistrationApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new RegistrationApi(client, configuration, basePath);
};

/**
 * RegistrationApi - interface
 * @export
 * @interface RegistrationApi
 */
export interface RegistrationApiInterface {
	/**
	 * @summary Проверка регистрационного кода
	 * @param {Api.RegistrationCheckCodeRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	registrationCheckCode(ctx: Context, request: Api.RegistrationCheckCodeRequest, options?: HttpRequestOptionsInit): Promise<RegistrationApi.RegistrationCheckCodeResponse>

	/**
	 * @summary Генерация кода саморегистрации оператора
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	registrationGenerateCode(ctx: Context, options?: HttpRequestOptionsInit): Promise<RegistrationApi.RegistrationGenerateCodeResponse>

	/**
	 * @summary Саморегистрация по коду
	 * @param {Api.RegistrationSelfRegisterRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	registrationSelfRegister(ctx: Context, request: Api.RegistrationSelfRegisterRequest, options?: HttpRequestOptionsInit): Promise<RegistrationApi.RegistrationSelfRegisterResponse>

}

/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
export class RegistrationApi extends BaseAPI implements RegistrationApiInterface {
	/**
	 * @summary Проверка регистрационного кода
	 * @param {Api.RegistrationCheckCodeRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public registrationCheckCode(ctx: Context, request: Api.RegistrationCheckCodeRequest, options?: HttpRequestOptionsInit) {
		return RegistrationApiFp(this.configuration).registrationCheckCode(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Генерация кода саморегистрации оператора
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public registrationGenerateCode(ctx: Context, options?: HttpRequestOptionsInit) {
		return RegistrationApiFp(this.configuration).registrationGenerateCode(ctx, options)(this.client, this.basePath);
	}

	/**
	 * @summary Саморегистрация по коду
	 * @param {Api.RegistrationSelfRegisterRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public registrationSelfRegister(ctx: Context, request: Api.RegistrationSelfRegisterRequest, options?: HttpRequestOptionsInit) {
		return RegistrationApiFp(this.configuration).registrationSelfRegister(ctx, request, options)(this.client, this.basePath);
	}

}
export namespace RolesApi {
	export type RolesGetByIdResponse =
		| RolesGetById200Response
	
	export interface RolesGetById200Response {
		status: 200
		contentType: 'application/json'
		body: Api.RolesGetById200Response
		headers?: undefined
	}
	
	export type RolesGetListResponse =
		| RolesGetList200Response
	
	export interface RolesGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.RolesGetList200Response
		headers?: undefined
	}
	
}

/**
 * RolesApi - request creator
 * @export
 */
export const RolesApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получение роли по ID
		 * @param {string} id <p>Идентификатор роли</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		rolesGetById(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling rolesGetById.');
			}

			let localVarPath = `/api/v1/roles/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение списка ролей
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		rolesGetList(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/roles/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получение роли по ID
		 * @param {string} id <p>Идентификатор роли</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		rolesGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<RolesApi.RolesGetByIdResponse> {
			const localVarHttpRequest = RolesApiHttpRequestCreator(configuration).rolesGetById(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.RolesGetById200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение списка ролей
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		rolesGetList(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<RolesApi.RolesGetListResponse> {
			const localVarHttpRequest = RolesApiHttpRequestCreator(configuration).rolesGetList(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.RolesGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory: FactoryFunction<RolesApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new RolesApi(client, configuration, basePath);
};

/**
 * RolesApi - interface
 * @export
 * @interface RolesApi
 */
export interface RolesApiInterface {
	/**
	 * @summary Получение роли по ID
	 * @param {string} id <p>Идентификатор роли</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	rolesGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<RolesApi.RolesGetByIdResponse>

	/**
	 * @summary Получение списка ролей
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	rolesGetList(ctx: Context, options?: HttpRequestOptionsInit): Promise<RolesApi.RolesGetListResponse>

}

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI implements RolesApiInterface {
	/**
	 * @summary Получение роли по ID
	 * @param {string} id <p>Идентификатор роли</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public rolesGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return RolesApiFp(this.configuration).rolesGetById(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение списка ролей
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public rolesGetList(ctx: Context, options?: HttpRequestOptionsInit) {
		return RolesApiFp(this.configuration).rolesGetList(ctx, options)(this.client, this.basePath);
	}

}
export namespace SalesPointsApi {
	export type SalesPointDeleteResponse =
		| SalesPointDelete200Response
	
	export interface SalesPointDelete200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
	export type SalesPointGetByIdResponse =
		| SalesPointGetById200Response
	
	export interface SalesPointGetById200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SalesPointGetById200Response
		headers?: undefined
	}
	
	export type SalesPointsAddResponse =
		| SalesPointsAdd200Response
	
	export interface SalesPointsAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SalesPointsAdd200Response
		headers?: undefined
	}
	
	export interface SalesPointsGetListParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Полнотекстовый поиск по адресу (улице и дому)</p>
		 * @type {string}
		 */
		search?: string
		/**
		 * @description <p>Фильтр по ID муниципального образования</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Фильтр по удаленным торговым объектам</p>
		 * @type {boolean}
		 */
		withDeleted?: boolean
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.SalesPointsGetListOrderBy}
		 */
		orderBy?: Api.SalesPointsGetListOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.SalesPointsGetListDirection}
		 */
		direction?: Api.SalesPointsGetListDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type SalesPointsGetListResponse =
		| SalesPointsGetList200Response
	
	export interface SalesPointsGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SalesPointsGetList200Response
		headers?: undefined
	}
	
	export type SalesPointUpdateResponse =
		| SalesPointUpdate200Response
	
	export interface SalesPointUpdate200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * SalesPointsApi - request creator
 * @export
 */
export const SalesPointsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Удаление торгового объекта
		 * @param {string} id <p>Идентификатор торгового объекта</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointDelete(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling salesPointDelete.');
			}

			let localVarPath = `/api/v1/sales-points/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'DELETE', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение торгового объекта по ID
		 * @param {string} id <p>Идентификатор торгового объекта</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointGetById(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling salesPointGetById.');
			}

			let localVarPath = `/api/v1/sales-points/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Добавление нового торгового объекта
		 * @param {Api.AddSalesPoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointsAdd(ctx: Context, request: Api.AddSalesPoint, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling salesPointsAdd.');
			}

			let localVarPath = `/api/v1/sales-points/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получить список торговых объектов
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый поиск по адресу (улице и дому)</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {boolean} [withDeleted] <p>Фильтр по удаленным торговым объектам</p>
		 * @param {Api.SalesPointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.SalesPointsGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointsGetList(ctx: Context, params: SalesPointsApi.SalesPointsGetListParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/sales-points/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.search !== undefined) {
				localVarQueryParameter.append('search', String(params.search));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.withDeleted !== undefined) {
				localVarQueryParameter.append('withDeleted', String(params.withDeleted));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Обновление торгового объекта
		 * @param {string} id <p>Идентификатор торгового объекта</p>
		 * @param {Api.UpdateSalesPoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointUpdate(ctx: Context, id: string, request: Api.UpdateSalesPoint, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling salesPointUpdate.');
			}
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling salesPointUpdate.');
			}

			let localVarPath = `/api/v1/sales-points/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'PATCH', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * SalesPointsApi - functional programming interface
 * @export
 */
export const SalesPointsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Удаление торгового объекта
		 * @param {string} id <p>Идентификатор торгового объекта</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SalesPointsApi.SalesPointDeleteResponse> {
			const localVarHttpRequest = SalesPointsApiHttpRequestCreator(configuration).salesPointDelete(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение торгового объекта по ID
		 * @param {string} id <p>Идентификатор торгового объекта</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SalesPointsApi.SalesPointGetByIdResponse> {
			const localVarHttpRequest = SalesPointsApiHttpRequestCreator(configuration).salesPointGetById(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SalesPointGetById200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Добавление нового торгового объекта
		 * @param {Api.AddSalesPoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointsAdd(ctx: Context, request: Api.AddSalesPoint, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SalesPointsApi.SalesPointsAddResponse> {
			const localVarHttpRequest = SalesPointsApiHttpRequestCreator(configuration).salesPointsAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SalesPointsAdd200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получить список торговых объектов
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [search] <p>Полнотекстовый поиск по адресу (улице и дому)</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {boolean} [withDeleted] <p>Фильтр по удаленным торговым объектам</p>
		 * @param {Api.SalesPointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.SalesPointsGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointsGetList(ctx: Context, params: SalesPointsApi.SalesPointsGetListParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SalesPointsApi.SalesPointsGetListResponse> {
			const localVarHttpRequest = SalesPointsApiHttpRequestCreator(configuration).salesPointsGetList(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SalesPointsGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Обновление торгового объекта
		 * @param {string} id <p>Идентификатор торгового объекта</p>
		 * @param {Api.UpdateSalesPoint} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		salesPointUpdate(ctx: Context, id: string, request: Api.UpdateSalesPoint, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SalesPointsApi.SalesPointUpdateResponse> {
			const localVarHttpRequest = SalesPointsApiHttpRequestCreator(configuration).salesPointUpdate(ctx, id, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * SalesPointsApi - factory interface
 * @export
 */
export const SalesPointsApiFactory: FactoryFunction<SalesPointsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new SalesPointsApi(client, configuration, basePath);
};

/**
 * SalesPointsApi - interface
 * @export
 * @interface SalesPointsApi
 */
export interface SalesPointsApiInterface {
	/**
	 * @summary Удаление торгового объекта
	 * @param {string} id <p>Идентификатор торгового объекта</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	salesPointDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<SalesPointsApi.SalesPointDeleteResponse>

	/**
	 * @summary Получение торгового объекта по ID
	 * @param {string} id <p>Идентификатор торгового объекта</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	salesPointGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<SalesPointsApi.SalesPointGetByIdResponse>

	/**
	 * @summary Добавление нового торгового объекта
	 * @param {Api.AddSalesPoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	salesPointsAdd(ctx: Context, request: Api.AddSalesPoint, options?: HttpRequestOptionsInit): Promise<SalesPointsApi.SalesPointsAddResponse>

	/**
	 * @summary Получить список торговых объектов
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый поиск по адресу (улице и дому)</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {boolean} [withDeleted] <p>Фильтр по удаленным торговым объектам</p>
	 * @param {Api.SalesPointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.SalesPointsGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	salesPointsGetList(ctx: Context, params: SalesPointsApi.SalesPointsGetListParameters, options?: HttpRequestOptionsInit): Promise<SalesPointsApi.SalesPointsGetListResponse>

	/**
	 * @summary Обновление торгового объекта
	 * @param {string} id <p>Идентификатор торгового объекта</p>
	 * @param {Api.UpdateSalesPoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	salesPointUpdate(ctx: Context, id: string, request: Api.UpdateSalesPoint, options?: HttpRequestOptionsInit): Promise<SalesPointsApi.SalesPointUpdateResponse>

}

/**
 * SalesPointsApi - object-oriented interface
 * @export
 * @class SalesPointsApi
 * @extends {BaseAPI}
 */
export class SalesPointsApi extends BaseAPI implements SalesPointsApiInterface {
	/**
	 * @summary Удаление торгового объекта
	 * @param {string} id <p>Идентификатор торгового объекта</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public salesPointDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return SalesPointsApiFp(this.configuration).salesPointDelete(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение торгового объекта по ID
	 * @param {string} id <p>Идентификатор торгового объекта</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public salesPointGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return SalesPointsApiFp(this.configuration).salesPointGetById(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Добавление нового торгового объекта
	 * @param {Api.AddSalesPoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public salesPointsAdd(ctx: Context, request: Api.AddSalesPoint, options?: HttpRequestOptionsInit) {
		return SalesPointsApiFp(this.configuration).salesPointsAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получить список торговых объектов
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [search] <p>Полнотекстовый поиск по адресу (улице и дому)</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {boolean} [withDeleted] <p>Фильтр по удаленным торговым объектам</p>
	 * @param {Api.SalesPointsGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.SalesPointsGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public salesPointsGetList(ctx: Context, params: SalesPointsApi.SalesPointsGetListParameters, options?: HttpRequestOptionsInit) {
		return SalesPointsApiFp(this.configuration).salesPointsGetList(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Обновление торгового объекта
	 * @param {string} id <p>Идентификатор торгового объекта</p>
	 * @param {Api.UpdateSalesPoint} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public salesPointUpdate(ctx: Context, id: string, request: Api.UpdateSalesPoint, options?: HttpRequestOptionsInit) {
		return SalesPointsApiFp(this.configuration).salesPointUpdate(ctx, id, request, options)(this.client, this.basePath);
	}

}
export namespace SyncApi {
	export type SyncCheckEventsResponse =
		| SyncCheckEvents200Response
	
	export interface SyncCheckEvents200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SyncCheckEvents200Response
		headers?: undefined
	}
	
	export interface SyncCountEventsParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
		 * @type {string}
		 */
		commonOrSpecificMEId?: string
		/**
		 * @description <p>Выдавать события начиная с версии (включительно)</p>
		 * @type {number}
		 */
		fromVersion?: number
		/**
		 * @description <p>Выдавать события до версии (включительно)</p>
		 * @type {number}
		 */
		toVersion?: number
	}
	
	export type SyncCountEventsResponse =
		| SyncCountEvents200Response
	
	export interface SyncCountEvents200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SyncCountEvents200Response
		headers?: undefined
	}
	
	export interface SyncExportEventsParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
		 * @type {string}
		 */
		commonOrSpecificMEId?: string
		/**
		 * @description <p>Фильтр по ID сущности</p>
		 * @type {string}
		 */
		entityId?: string
		/**
		 * @description <p>Выдавать события начиная с версии (включительно)</p>
		 * @type {number}
		 */
		fromVersion?: number
		/**
		 * @description <p>Выдавать события до версии (включительно)</p>
		 * @type {number}
		 */
		toVersion?: number
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.SyncExportEventsOrderBy}
		 */
		orderBy?: Api.SyncExportEventsOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.SyncExportEventsDirection}
		 */
		direction?: Api.SyncExportEventsDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type SyncExportEventsResponse =
		| SyncExportEvents200Response
	
	export interface SyncExportEvents200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SyncExportEvents200Response
		headers?: undefined
	}
	
	export type SyncGetInfoResponse =
		| SyncGetInfo200Response
	
	export interface SyncGetInfo200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SyncGetInfo200Response
		headers?: undefined
	}
	
	export type SyncImportEventsResponse =
		| SyncImportEvents200Response
	
	export interface SyncImportEvents200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SyncImportEvents200Response
		headers?: undefined
	}
	
}

/**
 * SyncApi - request creator
 * @export
 */
export const SyncApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Проверка списка событий на наличие
		 * @param {string[]} request <p>Список идентификаторов событий на проверку</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncCheckEvents(ctx: Context, request: string[], options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling syncCheckEvents.');
			}

			let localVarPath = `/api/v1/sync/events/check`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Подсчет событий, подходящих под фильтр
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
		 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
		 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncCountEvents(ctx: Context, params: SyncApi.SyncCountEventsParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/sync/events/count`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.commonOrSpecificMEId !== undefined) {
				localVarQueryParameter.append('commonOrSpecificMEId', String(params.commonOrSpecificMEId));
			}

			if (params.fromVersion !== undefined) {
				localVarQueryParameter.append('fromVersion', String(params.fromVersion));
			}

			if (params.toVersion !== undefined) {
				localVarQueryParameter.append('toVersion', String(params.toVersion));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение событий
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
		 * @param {string} [entityId] <p>Фильтр по ID сущности</p>
		 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
		 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
		 * @param {Api.SyncExportEventsOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.SyncExportEventsDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncExportEvents(ctx: Context, params: SyncApi.SyncExportEventsParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/sync/events/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.commonOrSpecificMEId !== undefined) {
				localVarQueryParameter.append('commonOrSpecificMEId', String(params.commonOrSpecificMEId));
			}

			if (params.entityId !== undefined) {
				localVarQueryParameter.append('entityId', String(params.entityId));
			}

			if (params.fromVersion !== undefined) {
				localVarQueryParameter.append('fromVersion', String(params.fromVersion));
			}

			if (params.toVersion !== undefined) {
				localVarQueryParameter.append('toVersion', String(params.toVersion));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение информации о хранилище
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncGetInfo(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/sync/events/info`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Импорт новых событий
		 * @param {Api.ModelEvent[]} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncImportEvents(ctx: Context, request: Api.ModelEvent[], options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling syncImportEvents.');
			}

			let localVarPath = `/api/v1/sync/events/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * SyncApi - functional programming interface
 * @export
 */
export const SyncApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Проверка списка событий на наличие
		 * @param {string[]} request <p>Список идентификаторов событий на проверку</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncCheckEvents(ctx: Context, request: string[], options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SyncApi.SyncCheckEventsResponse> {
			const localVarHttpRequest = SyncApiHttpRequestCreator(configuration).syncCheckEvents(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SyncCheckEvents200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Подсчет событий, подходящих под фильтр
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
		 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
		 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncCountEvents(ctx: Context, params: SyncApi.SyncCountEventsParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SyncApi.SyncCountEventsResponse> {
			const localVarHttpRequest = SyncApiHttpRequestCreator(configuration).syncCountEvents(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SyncCountEvents200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение событий
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
		 * @param {string} [entityId] <p>Фильтр по ID сущности</p>
		 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
		 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
		 * @param {Api.SyncExportEventsOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.SyncExportEventsDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncExportEvents(ctx: Context, params: SyncApi.SyncExportEventsParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SyncApi.SyncExportEventsResponse> {
			const localVarHttpRequest = SyncApiHttpRequestCreator(configuration).syncExportEvents(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SyncExportEvents200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение информации о хранилище
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncGetInfo(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SyncApi.SyncGetInfoResponse> {
			const localVarHttpRequest = SyncApiHttpRequestCreator(configuration).syncGetInfo(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SyncGetInfo200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Импорт новых событий
		 * @param {Api.ModelEvent[]} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		syncImportEvents(ctx: Context, request: Api.ModelEvent[], options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<SyncApi.SyncImportEventsResponse> {
			const localVarHttpRequest = SyncApiHttpRequestCreator(configuration).syncImportEvents(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SyncImportEvents200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * SyncApi - factory interface
 * @export
 */
export const SyncApiFactory: FactoryFunction<SyncApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new SyncApi(client, configuration, basePath);
};

/**
 * SyncApi - interface
 * @export
 * @interface SyncApi
 */
export interface SyncApiInterface {
	/**
	 * @summary Проверка списка событий на наличие
	 * @param {string[]} request <p>Список идентификаторов событий на проверку</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	syncCheckEvents(ctx: Context, request: string[], options?: HttpRequestOptionsInit): Promise<SyncApi.SyncCheckEventsResponse>

	/**
	 * @summary Подсчет событий, подходящих под фильтр
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
	 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
	 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	syncCountEvents(ctx: Context, params: SyncApi.SyncCountEventsParameters, options?: HttpRequestOptionsInit): Promise<SyncApi.SyncCountEventsResponse>

	/**
	 * @summary Получение событий
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
	 * @param {string} [entityId] <p>Фильтр по ID сущности</p>
	 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
	 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
	 * @param {Api.SyncExportEventsOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.SyncExportEventsDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	syncExportEvents(ctx: Context, params: SyncApi.SyncExportEventsParameters, options?: HttpRequestOptionsInit): Promise<SyncApi.SyncExportEventsResponse>

	/**
	 * @summary Получение информации о хранилище
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	syncGetInfo(ctx: Context, options?: HttpRequestOptionsInit): Promise<SyncApi.SyncGetInfoResponse>

	/**
	 * @summary Импорт новых событий
	 * @param {Api.ModelEvent[]} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	syncImportEvents(ctx: Context, request: Api.ModelEvent[], options?: HttpRequestOptionsInit): Promise<SyncApi.SyncImportEventsResponse>

}

/**
 * SyncApi - object-oriented interface
 * @export
 * @class SyncApi
 * @extends {BaseAPI}
 */
export class SyncApi extends BaseAPI implements SyncApiInterface {
	/**
	 * @summary Проверка списка событий на наличие
	 * @param {string[]} request <p>Список идентификаторов событий на проверку</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public syncCheckEvents(ctx: Context, request: string[], options?: HttpRequestOptionsInit) {
		return SyncApiFp(this.configuration).syncCheckEvents(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Подсчет событий, подходящих под фильтр
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
	 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
	 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public syncCountEvents(ctx: Context, params: SyncApi.SyncCountEventsParameters, options?: HttpRequestOptionsInit) {
		return SyncApiFp(this.configuration).syncCountEvents(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение событий
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [commonOrSpecificMEId] <p>Выдавать только общие события и относящиеся к конкретному указанному МО по ID</p>
	 * @param {string} [entityId] <p>Фильтр по ID сущности</p>
	 * @param {number} [fromVersion] <p>Выдавать события начиная с версии (включительно)</p>
	 * @param {number} [toVersion] <p>Выдавать события до версии (включительно)</p>
	 * @param {Api.SyncExportEventsOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.SyncExportEventsDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public syncExportEvents(ctx: Context, params: SyncApi.SyncExportEventsParameters, options?: HttpRequestOptionsInit) {
		return SyncApiFp(this.configuration).syncExportEvents(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение информации о хранилище
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public syncGetInfo(ctx: Context, options?: HttpRequestOptionsInit) {
		return SyncApiFp(this.configuration).syncGetInfo(ctx, options)(this.client, this.basePath);
	}

	/**
	 * @summary Импорт новых событий
	 * @param {Api.ModelEvent[]} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public syncImportEvents(ctx: Context, request: Api.ModelEvent[], options?: HttpRequestOptionsInit) {
		return SyncApiFp(this.configuration).syncImportEvents(ctx, request, options)(this.client, this.basePath);
	}

}
export namespace UpdatesApi {
	export type UpdatesGetLatestResponse =
		| UpdatesGetLatest200Response
	
	export interface UpdatesGetLatest200Response {
		status: 200
		contentType: 'application/json'
		body: Api.ObjectResponse | Api.UpdatesGetLatest200Response.ObjectValue | Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * UpdatesApi - request creator
 * @export
 */
export const UpdatesApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Получение актуального обновления
		 * @param {string} version <p>Текущая версия приложения</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		updatesGetLatest(ctx: Context, version: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'version' is not null or undefined
			if (version === null || version === undefined) {
				throw new RequiredError('version', 'Required parameter version was null or undefined when calling updatesGetLatest.');
			}

			let localVarPath = `/api/v1/updates/latest`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (version !== undefined) {
				localVarQueryParameter.append('version', String(version));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * UpdatesApi - functional programming interface
 * @export
 */
export const UpdatesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Получение актуального обновления
		 * @param {string} version <p>Текущая версия приложения</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		updatesGetLatest(ctx: Context, version: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UpdatesApi.UpdatesGetLatestResponse> {
			const localVarHttpRequest = UpdatesApiHttpRequestCreator(configuration).updatesGetLatest(ctx, version, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.ObjectResponse | Api.UpdatesGetLatest200Response.ObjectValue | Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * UpdatesApi - factory interface
 * @export
 */
export const UpdatesApiFactory: FactoryFunction<UpdatesApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new UpdatesApi(client, configuration, basePath);
};

/**
 * UpdatesApi - interface
 * @export
 * @interface UpdatesApi
 */
export interface UpdatesApiInterface {
	/**
	 * @summary Получение актуального обновления
	 * @param {string} version <p>Текущая версия приложения</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	updatesGetLatest(ctx: Context, version: string, options?: HttpRequestOptionsInit): Promise<UpdatesApi.UpdatesGetLatestResponse>

}

/**
 * UpdatesApi - object-oriented interface
 * @export
 * @class UpdatesApi
 * @extends {BaseAPI}
 */
export class UpdatesApi extends BaseAPI implements UpdatesApiInterface {
	/**
	 * @summary Получение актуального обновления
	 * @param {string} version <p>Текущая версия приложения</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public updatesGetLatest(ctx: Context, version: string, options?: HttpRequestOptionsInit) {
		return UpdatesApiFp(this.configuration).updatesGetLatest(ctx, version, options)(this.client, this.basePath);
	}

}
export namespace UsedCardsStatsApi {
	export type UsedCardsStatsAddResponse =
		| UsedCardsStatsAdd200Response
	
	export interface UsedCardsStatsAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.UsedCardsStatsAdd200Response
		headers?: undefined
	}
	
	export interface UsedCardsStatsFormReportParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Фильтр по ID муниципального образования</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Фильтр по ID торгового объекта</p>
		 * @type {string}
		 */
		salesPointId?: string
		/**
		 * @description <p>Фильтр по дате создания записи (от)</p>
		 * @type {string}
		 */
		dateFrom?: string
		/**
		 * @description <p>Фильтр по дате создания записи (до)</p>
		 * @type {string}
		 */
		dateTo?: string
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.UsedCardsStatsFormReportOrderBy}
		 */
		orderBy?: Api.UsedCardsStatsFormReportOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.UsedCardsStatsFormReportDirection}
		 */
		direction?: Api.UsedCardsStatsFormReportDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type UsedCardsStatsFormReportResponse =
		| UsedCardsStatsFormReport200Response
	
	export interface UsedCardsStatsFormReport200Response {
		status: 200
		contentType: 'application/json'
		body: Api.UsedCardsStatsFormReport200Response
		headers?: undefined
	}
	
}

/**
 * UsedCardsStatsApi - request creator
 * @export
 */
export const UsedCardsStatsApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление новой записи об использованных картах
		 * @param {Api.AddUsedCardsStat} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usedCardsStatsAdd(ctx: Context, request: Api.AddUsedCardsStat, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling usedCardsStatsAdd.');
			}

			let localVarPath = `/api/v1/used-cards-stats/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получить список записей учёта использованных карт
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [salesPointId] <p>Фильтр по ID торгового объекта</p>
		 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
		 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
		 * @param {Api.UsedCardsStatsFormReportOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.UsedCardsStatsFormReportDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usedCardsStatsFormReport(ctx: Context, params: UsedCardsStatsApi.UsedCardsStatsFormReportParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/used-cards-stats/form-report`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.salesPointId !== undefined) {
				localVarQueryParameter.append('salesPointId', String(params.salesPointId));
			}

			if (params.dateFrom !== undefined) {
				localVarQueryParameter.append('dateFrom', String(params.dateFrom));
			}

			if (params.dateTo !== undefined) {
				localVarQueryParameter.append('dateTo', String(params.dateTo));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * UsedCardsStatsApi - functional programming interface
 * @export
 */
export const UsedCardsStatsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление новой записи об использованных картах
		 * @param {Api.AddUsedCardsStat} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usedCardsStatsAdd(ctx: Context, request: Api.AddUsedCardsStat, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsedCardsStatsApi.UsedCardsStatsAddResponse> {
			const localVarHttpRequest = UsedCardsStatsApiHttpRequestCreator(configuration).usedCardsStatsAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.UsedCardsStatsAdd200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получить список записей учёта использованных карт
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [salesPointId] <p>Фильтр по ID торгового объекта</p>
		 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
		 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
		 * @param {Api.UsedCardsStatsFormReportOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.UsedCardsStatsFormReportDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usedCardsStatsFormReport(ctx: Context, params: UsedCardsStatsApi.UsedCardsStatsFormReportParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsedCardsStatsApi.UsedCardsStatsFormReportResponse> {
			const localVarHttpRequest = UsedCardsStatsApiHttpRequestCreator(configuration).usedCardsStatsFormReport(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.UsedCardsStatsFormReport200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * UsedCardsStatsApi - factory interface
 * @export
 */
export const UsedCardsStatsApiFactory: FactoryFunction<UsedCardsStatsApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new UsedCardsStatsApi(client, configuration, basePath);
};

/**
 * UsedCardsStatsApi - interface
 * @export
 * @interface UsedCardsStatsApi
 */
export interface UsedCardsStatsApiInterface {
	/**
	 * @summary Добавление новой записи об использованных картах
	 * @param {Api.AddUsedCardsStat} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usedCardsStatsAdd(ctx: Context, request: Api.AddUsedCardsStat, options?: HttpRequestOptionsInit): Promise<UsedCardsStatsApi.UsedCardsStatsAddResponse>

	/**
	 * @summary Получить список записей учёта использованных карт
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [salesPointId] <p>Фильтр по ID торгового объекта</p>
	 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
	 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
	 * @param {Api.UsedCardsStatsFormReportOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.UsedCardsStatsFormReportDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usedCardsStatsFormReport(ctx: Context, params: UsedCardsStatsApi.UsedCardsStatsFormReportParameters, options?: HttpRequestOptionsInit): Promise<UsedCardsStatsApi.UsedCardsStatsFormReportResponse>

}

/**
 * UsedCardsStatsApi - object-oriented interface
 * @export
 * @class UsedCardsStatsApi
 * @extends {BaseAPI}
 */
export class UsedCardsStatsApi extends BaseAPI implements UsedCardsStatsApiInterface {
	/**
	 * @summary Добавление новой записи об использованных картах
	 * @param {Api.AddUsedCardsStat} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usedCardsStatsAdd(ctx: Context, request: Api.AddUsedCardsStat, options?: HttpRequestOptionsInit) {
		return UsedCardsStatsApiFp(this.configuration).usedCardsStatsAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получить список записей учёта использованных карт
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [salesPointId] <p>Фильтр по ID торгового объекта</p>
	 * @param {string} [dateFrom] <p>Фильтр по дате создания записи (от)</p>
	 * @param {string} [dateTo] <p>Фильтр по дате создания записи (до)</p>
	 * @param {Api.UsedCardsStatsFormReportOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.UsedCardsStatsFormReportDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usedCardsStatsFormReport(ctx: Context, params: UsedCardsStatsApi.UsedCardsStatsFormReportParameters, options?: HttpRequestOptionsInit) {
		return UsedCardsStatsApiFp(this.configuration).usedCardsStatsFormReport(ctx, params, options)(this.client, this.basePath);
	}

}
export namespace UsersApi {
	export type UsersAddResponse =
		| UsersAdd200Response
	
	export interface UsersAdd200Response {
		status: 200
		contentType: 'application/json'
		body: Api.UsersAdd200Response
		headers?: undefined
	}
	
	export type UsersDeleteResponse =
		| UsersDelete200Response
	
	export interface UsersDelete200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
	export type UsersGetByIdResponse =
		| UsersGetById200Response
	
	export interface UsersGetById200Response {
		status: 200
		contentType: 'application/json'
		body: Api.UsersGetById200Response
		headers?: undefined
	}
	
	export type UsersGetControlQuestionsResponse =
		| UsersGetControlQuestions200Response
	
	export interface UsersGetControlQuestions200Response {
		status: 200
		contentType: 'application/json'
		body: Api.UsersGetControlQuestions200Response
		headers?: undefined
	}
	
	export interface UsersGetListParameters {
		/**
		 * @description <p>Фильтр по списку ID, разделенных запятой</p>
		 * @type {string[]}
		 */
		ids?: string[]
		/**
		 * @description <p>Фильтр по ID муниципального образования</p>
		 * @type {string}
		 */
		municipalEntityId?: string
		/**
		 * @description <p>Фильтр по ID пункта выдачи карт</p>
		 * @type {string}
		 */
		cardIssuePointId?: string
		/**
		 * @description <p>Фильтр по ID роли пользователя</p>
		 * @type {string}
		 */
		roleId?: string
		/**
		 * @description <p>Полнотекстовый фильтр по ФИО</p>
		 * @type {string}
		 */
		search?: string
		/**
		 * @description <p>Фильтр по списку статусов, разделенных запятой</p>
		 * @type {Api.UsersGetListStatuses[]}
		 */
		statuses?: Api.UsersGetListStatuses[]
		/**
		 * @description <p>Сортировка по полю</p>
		 * @type {Api.UsersGetListOrderBy}
		 */
		orderBy?: Api.UsersGetListOrderBy
		/**
		 * @description <p>Направление сортировки</p>
		 * @type {Api.UsersGetListDirection}
		 */
		direction?: Api.UsersGetListDirection
		/**
		 * @description <p>Выдавать записи начиная с указанного индекса</p>
		 * @type {number}
		 */
		aFrom?: number
		/**
		 * @description <p>Выдавать заданное количество записей</p>
		 * @type {number}
		 */
		count?: number
	}
	
	export type UsersGetListResponse =
		| UsersGetList200Response
	
	export interface UsersGetList200Response {
		status: 200
		contentType: 'application/json'
		body: Api.UsersGetList200Response
		headers?: undefined
	}
	
	export type UsersUpdateResponse =
		| UsersUpdate200Response
	
	export interface UsersUpdate200Response {
		status: 200
		contentType: 'application/json'
		body: Api.SuccessResponse
		headers?: undefined
	}
	
}

/**
 * UsersApi - request creator
 * @export
 */
export const UsersApiHttpRequestCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление нового пользователя
		 * @param {Api.AddUser} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersAdd(ctx: Context, request: Api.AddUser, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling usersAdd.');
			}

			let localVarPath = `/api/v1/users/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'POST', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Удаление пользователя
		 * @param {string} id <p>Идентификатор пользователя</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersDelete(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling usersDelete.');
			}

			let localVarPath = `/api/v1/users/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'DELETE', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение пользователя по ID
		 * @param {string} id <p>Идентификатор пользователя</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersGetById(ctx: Context, id: string, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling usersGetById.');
			}

			let localVarPath = `/api/v1/users/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Запрос списка контрольных вопросов
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersGetControlQuestions(ctx: Context, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/users/control-questions`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Получение списка пользователей
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
		 * @param {string} [roleId] <p>Фильтр по ID роли пользователя</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по ФИО</p>
		 * @param {Api.UsersGetListStatuses[]} [statuses] <p>Фильтр по списку статусов, разделенных запятой</p>
		 * @param {Api.UsersGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.UsersGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersGetList(ctx: Context, params: UsersApi.UsersGetListParameters, options: HttpRequestOptionsInit = {}): HttpRequest {

			let localVarPath = `/api/v1/users/`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'GET', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			if (params.ids !== undefined) {
				/* array form */
				localVarQueryParameter.append('ids', params.ids.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.municipalEntityId !== undefined) {
				localVarQueryParameter.append('municipalEntityId', String(params.municipalEntityId));
			}

			if (params.cardIssuePointId !== undefined) {
				localVarQueryParameter.append('cardIssuePointId', String(params.cardIssuePointId));
			}

			if (params.roleId !== undefined) {
				localVarQueryParameter.append('roleId', String(params.roleId));
			}

			if (params.search !== undefined) {
				localVarQueryParameter.append('search', String(params.search));
			}

			if (params.statuses !== undefined) {
				/* array form */
				localVarQueryParameter.append('statuses', params.statuses.map(localVarArrayMapElement => escape(String(localVarArrayMapElement))).join('💩'));
			}

			if (params.orderBy !== undefined) {
				localVarQueryParameter.append('orderBy', String(params.orderBy));
			}

			if (params.direction !== undefined) {
				localVarQueryParameter.append('direction', String(params.direction));
			}

			if (params.aFrom !== undefined) {
				localVarQueryParameter.append('from', String(params.aFrom));
			}

			if (params.count !== undefined) {
				localVarQueryParameter.append('count', String(params.count));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * @summary Обновление пользователя
		 * @param {string} id <p>Идентификатор пользователя</p>
		 * @param {Api.UpdateUser} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersUpdate(ctx: Context, id: string, request: Api.UpdateUser, options: HttpRequestOptionsInit = {}): HttpRequest {
			// verify required parameter 'id' is not null or undefined
			if (id === null || id === undefined) {
				throw new RequiredError('id', 'Required parameter id was null or undefined when calling usersUpdate.');
			}
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling usersUpdate.');
			}

			let localVarPath = `/api/v1/users/{id}`
				.replace('{id}', encodeURIComponent(String(id)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: HttpRequestOptions = { method: 'PATCH', ...options };
			const localVarHeaderParameter: HttpRequestHeaders = options.headers ?? {
				[HttpHeader.X_REQUEST_ID]: ctx.traceId,
			};
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			// authentication auth required
			// http authorization required
			if (configuration && configuration.authorization) {
				const localVarAuthorizationValue = typeof configuration.authorization === 'function'
					? configuration.authorization('auth')
					: configuration.authorization;
				if (localVarAuthorizationValue !== null) {
					localVarHeaderParameter["Authorization"] = "Bearer " + localVarAuthorizationValue;
				}
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			localVarRequestOptions.headers = localVarHeaderParameter;

			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString().replaceAll('%F0%9F%92%A9', ',');
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * @summary Добавление нового пользователя
		 * @param {Api.AddUser} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersAdd(ctx: Context, request: Api.AddUser, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsersApi.UsersAddResponse> {
			const localVarHttpRequest = UsersApiHttpRequestCreator(configuration).usersAdd(ctx, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.UsersAdd200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Удаление пользователя
		 * @param {string} id <p>Идентификатор пользователя</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsersApi.UsersDeleteResponse> {
			const localVarHttpRequest = UsersApiHttpRequestCreator(configuration).usersDelete(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение пользователя по ID
		 * @param {string} id <p>Идентификатор пользователя</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsersApi.UsersGetByIdResponse> {
			const localVarHttpRequest = UsersApiHttpRequestCreator(configuration).usersGetById(ctx, id, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.UsersGetById200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Запрос списка контрольных вопросов
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersGetControlQuestions(ctx: Context, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsersApi.UsersGetControlQuestionsResponse> {
			const localVarHttpRequest = UsersApiHttpRequestCreator(configuration).usersGetControlQuestions(ctx, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.UsersGetControlQuestions200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Получение списка пользователей
		 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
		 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
		 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
		 * @param {string} [roleId] <p>Фильтр по ID роли пользователя</p>
		 * @param {string} [search] <p>Полнотекстовый фильтр по ФИО</p>
		 * @param {Api.UsersGetListStatuses[]} [statuses] <p>Фильтр по списку статусов, разделенных запятой</p>
		 * @param {Api.UsersGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
		 * @param {Api.UsersGetListDirection} [direction] <p>Направление сортировки</p>
		 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
		 * @param {number} [count] <p>Выдавать заданное количество записей</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersGetList(ctx: Context, params: UsersApi.UsersGetListParameters, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsersApi.UsersGetListResponse> {
			const localVarHttpRequest = UsersApiHttpRequestCreator(configuration).usersGetList(ctx, params, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.UsersGetList200Response,
						}
					}
					throw response;
				}
				throw response;
			};
		},
		/**
		 * @summary Обновление пользователя
		 * @param {string} id <p>Идентификатор пользователя</p>
		 * @param {Api.UpdateUser} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		usersUpdate(ctx: Context, id: string, request: Api.UpdateUser, options?: HttpRequestOptionsInit): (client: HttpClient, basePath?: string) => Promise<UsersApi.UsersUpdateResponse> {
			const localVarHttpRequest = UsersApiHttpRequestCreator(configuration).usersUpdate(ctx, id, request, options);
			return async (client: HttpClient, basePath: string = BASE_PATH) => {
				const response = await client.exec(ctx, basePath + localVarHttpRequest.url, localVarHttpRequest.options)
				const contentType = response.headers.get('Content-Type');
				const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

				if (response.status === 200) {
					if (mimeType === 'application/json') {
						return {
							status: 200,
							contentType: 'application/json',
							body: await response.json() as Api.SuccessResponse,
						}
					}
					throw response;
				}
				throw response;
			};
		},
	}
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory: FactoryFunction<UsersApiInterface> = function (client: HttpClient, configuration?: Configuration, basePath?: string) {
	return new UsersApi(client, configuration, basePath);
};

/**
 * UsersApi - interface
 * @export
 * @interface UsersApi
 */
export interface UsersApiInterface {
	/**
	 * @summary Добавление нового пользователя
	 * @param {Api.AddUser} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usersAdd(ctx: Context, request: Api.AddUser, options?: HttpRequestOptionsInit): Promise<UsersApi.UsersAddResponse>

	/**
	 * @summary Удаление пользователя
	 * @param {string} id <p>Идентификатор пользователя</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usersDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<UsersApi.UsersDeleteResponse>

	/**
	 * @summary Получение пользователя по ID
	 * @param {string} id <p>Идентификатор пользователя</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usersGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit): Promise<UsersApi.UsersGetByIdResponse>

	/**
	 * @summary Запрос списка контрольных вопросов
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usersGetControlQuestions(ctx: Context, options?: HttpRequestOptionsInit): Promise<UsersApi.UsersGetControlQuestionsResponse>

	/**
	 * @summary Получение списка пользователей
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
	 * @param {string} [roleId] <p>Фильтр по ID роли пользователя</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по ФИО</p>
	 * @param {Api.UsersGetListStatuses[]} [statuses] <p>Фильтр по списку статусов, разделенных запятой</p>
	 * @param {Api.UsersGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.UsersGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usersGetList(ctx: Context, params: UsersApi.UsersGetListParameters, options?: HttpRequestOptionsInit): Promise<UsersApi.UsersGetListResponse>

	/**
	 * @summary Обновление пользователя
	 * @param {string} id <p>Идентификатор пользователя</p>
	 * @param {Api.UpdateUser} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	usersUpdate(ctx: Context, id: string, request: Api.UpdateUser, options?: HttpRequestOptionsInit): Promise<UsersApi.UsersUpdateResponse>

}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
	/**
	 * @summary Добавление нового пользователя
	 * @param {Api.AddUser} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usersAdd(ctx: Context, request: Api.AddUser, options?: HttpRequestOptionsInit) {
		return UsersApiFp(this.configuration).usersAdd(ctx, request, options)(this.client, this.basePath);
	}

	/**
	 * @summary Удаление пользователя
	 * @param {string} id <p>Идентификатор пользователя</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usersDelete(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return UsersApiFp(this.configuration).usersDelete(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение пользователя по ID
	 * @param {string} id <p>Идентификатор пользователя</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usersGetById(ctx: Context, id: string, options?: HttpRequestOptionsInit) {
		return UsersApiFp(this.configuration).usersGetById(ctx, id, options)(this.client, this.basePath);
	}

	/**
	 * @summary Запрос списка контрольных вопросов
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usersGetControlQuestions(ctx: Context, options?: HttpRequestOptionsInit) {
		return UsersApiFp(this.configuration).usersGetControlQuestions(ctx, options)(this.client, this.basePath);
	}

	/**
	 * @summary Получение списка пользователей
	 * @param {string[]} [ids] <p>Фильтр по списку ID, разделенных запятой</p>
	 * @param {string} [municipalEntityId] <p>Фильтр по ID муниципального образования</p>
	 * @param {string} [cardIssuePointId] <p>Фильтр по ID пункта выдачи карт</p>
	 * @param {string} [roleId] <p>Фильтр по ID роли пользователя</p>
	 * @param {string} [search] <p>Полнотекстовый фильтр по ФИО</p>
	 * @param {Api.UsersGetListStatuses[]} [statuses] <p>Фильтр по списку статусов, разделенных запятой</p>
	 * @param {Api.UsersGetListOrderBy} [orderBy] <p>Сортировка по полю</p>
	 * @param {Api.UsersGetListDirection} [direction] <p>Направление сортировки</p>
	 * @param {number} [aFrom] <p>Выдавать записи начиная с указанного индекса</p>
	 * @param {number} [count] <p>Выдавать заданное количество записей</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usersGetList(ctx: Context, params: UsersApi.UsersGetListParameters, options?: HttpRequestOptionsInit) {
		return UsersApiFp(this.configuration).usersGetList(ctx, params, options)(this.client, this.basePath);
	}

	/**
	 * @summary Обновление пользователя
	 * @param {string} id <p>Идентификатор пользователя</p>
	 * @param {Api.UpdateUser} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public usersUpdate(ctx: Context, id: string, request: Api.UpdateUser, options?: HttpRequestOptionsInit) {
		return UsersApiFp(this.configuration).usersUpdate(ctx, id, request, options)(this.client, this.basePath);
	}

}

/**
 * We sometimes represent dates as strings (in models) and as Dates (in parameters) so this
 * function converts them both to a string.
 */
function dateToString(value: Date | string | undefined): string | undefined {
	if (value instanceof Date) {
		return value.toISOString();
	} else if (typeof value === 'string') {
		return value;
	} else {
		return undefined;
	}
}